// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type ServerSentEventsResult, type TDataShape } from './client';
import { client } from './client.gen';
import type { AcceptPoolConsentData, AcceptPoolConsentErrors, AcceptPoolConsentResponses, AcceptStudioAgencyInviteData, AcceptStudioAgencyInviteErrors, AcceptStudioAgencyInviteResponses, AcquireQuestionLibraryLockData, AcquireQuestionLibraryLockResponses, ActivateQuestionLibraryData, ActivateQuestionLibraryResponses, AddAccountMemberData, AddAccountMemberErrors, AddAccountMemberResponses, AddAgencyHubGroupInfluencerData, AddAgencyHubGroupInfluencerErrors, AddAgencyHubGroupInfluencerResponses, AddAgencyUserData, AddAgencyUserErrors, AddAgencyUserResponses, AddAskPagePostData, AddAskPagePostErrors, AddAskPagePostResponses, AddClipToBoardData, AddClipToBoardErrors, AddClipToBoardResponses, AddInfluencerData, AddInfluencerResponses, AddPaymentMethodData, AddPaymentMethodErrors, AddPaymentMethodResponses, AdminAcceptAgencyHubInfluencerInviteData, AdminAcceptAgencyHubInfluencerInviteErrors, AdminAcceptAgencyHubInfluencerInviteResponses, AdminAcceptConnectedAccountData, AdminAcceptConnectedAccountErrors, AdminAcceptConnectedAccountResponses, ApplyAdminFaultedAccountHandleData, ApplyAdminFaultedAccountHandleErrors, ApplyAdminFaultedAccountHandleResponses, ApproveInfluencerData, ApproveInfluencerErrors, ApproveInfluencerResponses, AskFollowUpQuestionByIdData, AskFollowUpQuestionByIdErrors, AskFollowUpQuestionByIdResponses, AskFollowUpQuestionData, AskFollowUpQuestionErrors, AskFollowUpQuestionResponses, AskPublicAskPageQuestionData, AskPublicAskPageQuestionErrors, AskPublicAskPageQuestionResponses, BackfillInfluencerData, BackfillInfluencerErrors, BackfillInfluencerResponses, BackfillPostsData, BackfillPostsErrors, BackfillPostsForAllAccountsData, BackfillPostsForAllAccountsErrors, BackfillPostsForAllAccountsResponses, BackfillPostsResponses, BulkDeleteInfluencerVideosData, BulkDeleteInfluencerVideosErrors, BulkDeleteInfluencerVideosResponses, CancelAdminAskPageInsightsRebuildData, CancelAdminAskPageInsightsRebuildErrors, CancelAdminAskPageInsightsRebuildResponses, CancelMyAskPageSubscriptionData, CancelMyAskPageSubscriptionErrors, CancelMyAskPageSubscriptionResponses, CancelSubscriptionData, CancelSubscriptionErrors, CancelSubscriptionResponses, ChangeAccountPlanData, ChangeAccountPlanErrors, ChangeAccountPlanResponses, ChangeAccountToCustomPlanData, ChangeAccountToCustomPlanErrors, ChangeAccountToCustomPlanResponses, ChangeAskGvtPlanData, ChangeAskGvtPlanErrors, ChangeAskGvtPlanResponses, ChangeSubscriptionPlanData, ChangeSubscriptionPlanErrors, ChangeSubscriptionPlanResponses, CheckHandleData, CheckHandleErrors, CheckHandleResponses, CheckPublicAskPageQuestionData, CheckPublicAskPageQuestionErrors, CheckPublicAskPageQuestionResponses, ClaimAskPageAnswerData, ClaimAskPageAnswerErrors, ClaimAskPageAnswerResponses, CollectPostsData, CollectPostsForAllAccountsData, CollectPostsForAllAccountsResponses, CollectPostsResponses, CompleteCreatorSetupData, CompleteCreatorSetupErrors, CompleteCreatorSetupResponses, CompleteUploadData, CompleteUploadErrors, CompleteUploadResponses, ConfirmAskPagePurchaseData, ConfirmAskPagePurchaseErrors, ConfirmAskPagePurchaseResponses, ConfirmSubscriptionData, ConfirmSubscriptionErrors, ConfirmSubscriptionResponses, ConfirmTopupPurchaseData, ConfirmTopupPurchaseErrors, ConfirmTopupPurchaseResponses, ConfirmUserDeletionData, ConfirmUserDeletionErrors, ConfirmUserDeletionResponses, ConnectSocialAccountData, ConnectSocialAccountErrors, ConnectSocialAccountForDiscoveryData, ConnectSocialAccountForDiscoveryErrors, ConnectSocialAccountForDiscoveryResponses, ConnectSocialAccountResponses, CoverAskPageInsightsBriefData, CoverAskPageInsightsBriefErrors, CoverAskPageInsightsBriefResponses, CreateAccountBillingData, CreateAccountBillingErrors, CreateAccountBillingResponses, CreateAccountData, CreateAccountErrors, CreateAccountResponses, CreateAgencyData, CreateAgencyErrors, CreateAgencyHubGroupData, CreateAgencyHubGroupErrors, CreateAgencyHubGroupResponses, CreateAgencyResponses, CreateAnonymousAskPageShareData, CreateAnonymousAskPageShareErrors, CreateAnonymousAskPageShareResponses, CreateArtifactData, CreateArtifactErrors, CreateArtifactResponses, CreateAskPagePoolData, CreateAskPagePoolErrors, CreateAskPagePoolResponses, CreateAskPageShareData, CreateAskPageShareErrors, CreateAskPageShareResponses, CreateBoardData, CreateBoardErrors, CreateBoardResponses, CreateCardSetupIntentData, CreateCardSetupIntentErrors, CreateCardSetupIntentResponses, CreatePoolAnalysisCategoryData, CreatePoolAnalysisCategoryErrors, CreatePoolAnalysisCategoryResponses, CreatePoolData, CreatePoolErrors, CreateProjectData, CreateProjectErrors, CreateProjectResponses, CreatePublicPoolData, CreatePublicPoolErrors, CreatePublicPoolResponses, CreateQuestionData, CreateQuestionErrors, CreateQuestionLibraryData, CreateQuestionLibraryResponses, CreateQuestionResponses, CreateUserData, CreateUserErrors, CreateUserResponses, DeclinePoolConsentData, DeclinePoolConsentErrors, DeclinePoolConsentResponses, DeclineStudioAgencyInviteData, DeclineStudioAgencyInviteErrors, DeclineStudioAgencyInviteResponses, DeleteAgencyData, DeleteAgencyErrors, DeleteAgencyHubGroupData, DeleteAgencyHubGroupErrors, DeleteAgencyHubGroupResponses, DeleteAgencyResponses, DeleteArtifactsData, DeleteArtifactsErrors, DeleteArtifactsResponses, DeleteBoardData, DeleteBoardErrors, DeleteBoardResponses, DeleteClipsData, DeleteClipsErrors, DeleteClipsResponses, DeleteInfluencerData, DeleteInfluencerErrors, DeleteInfluencerResponses, DeleteLoadTestBatchData, DeleteLoadTestBatchErrors, DeleteLoadTestBatchResponses, DeletePoolAnalysisCategoryData, DeletePoolAnalysisCategoryErrors, DeletePoolAnalysisCategoryResponses, DeletePoolData, DeletePoolErrors, DeletePoolResponses, DeleteProjectData, DeleteProjectErrors, DeleteProjectResponses, DeleteProjectSocialChannelsData, DeleteProjectSocialChannelsErrors, DeleteProjectSocialChannelsResponses, DeletePublicPoolData, DeletePublicPoolErrors, DeletePublicPoolResponses, DeleteQuestionData, DeleteQuestionErrors, DeleteQuestionLibraryData, DeleteQuestionLibraryResponses, DeleteQuestionResponses, DeleteStudioDraftData, DeleteStudioDraftErrors, DeleteStudioDraftResponses, DeleteUserData, DeleteUserErrors, DeleteUserQuestionData, DeleteUserQuestionErrors, DeleteUserQuestionResponses, DeleteUserResponses, DeleteVideoData, DeleteVideoErrors, DeleteVideoResponses, DisableAdminFaultedAccountData, DisableAdminFaultedAccountErrors, DisableAdminFaultedAccountResponses, DisconnectConnectedAccountData, DisconnectConnectedAccountErrors, DisconnectConnectedAccountResponses, DownloadAllAssetsData, DownloadAllAssetsErrors, DownloadAllAssetsResponses, DownloadArtifactFileData, DownloadArtifactFileErrors, DownloadArtifactFileResponses, DownloadAskPageBannerSourceData, DownloadAskPageBannerSourceErrors, DownloadAskPageBannerSourceResponses, DownloadAssetsData, DownloadAssetsErrors, DownloadAssetsResponses, EstimateAdminAskPageInsightsRebuildAllData, EstimateAdminAskPageInsightsRebuildAllErrors, EstimateAdminAskPageInsightsRebuildAllResponses, ExecuteProjectJobData, ExecuteProjectJobResponses, FailUploadData, FailUploadErrors, FailUploadResponses, FollowBoardData, FollowBoardErrors, FollowBoardResponses, ForceDeleteQuestionLibraryData, ForceDeleteQuestionLibraryErrors, ForceDeleteQuestionLibraryResponses, GenerateAskPageInsightsSummaryData, GenerateAskPageInsightsSummaryErrors, GenerateAskPageInsightsSummaryResponses, GetAccountBillingChargeReceiptData, GetAccountBillingChargeReceiptErrors, GetAccountBillingChargeReceiptResponses, GetAccountBillingChargesData, GetAccountBillingChargesErrors, GetAccountBillingChargesResponses, GetAccountBillingData, GetAccountBillingPaymentMethodsData, GetAccountBillingPaymentMethodsErrors, GetAccountBillingPaymentMethodsResponses, GetAccountBillingResponses, GetAccountData, GetAccountErrors, GetAccountFeatureFlagsData, GetAccountFeatureFlagsErrors, GetAccountFeatureFlagsResponses, GetAccountMeteringBalanceData, GetAccountMeteringBalanceErrors, GetAccountMeteringBalanceResponses, GetAccountMeteringGrantsData, GetAccountMeteringGrantsErrors, GetAccountMeteringGrantsResponses, GetAccountMeteringPlanData, GetAccountMeteringPlanErrors, GetAccountMeteringPlanResponses, GetAccountMeteringUsageData, GetAccountMeteringUsageErrors, GetAccountMeteringUsageResponses, GetAccountResponses, GetActiveQuestionLibraryData, GetActiveQuestionLibraryErrors, GetActiveQuestionLibraryResponses, GetAdminAccountBillingData, GetAdminAccountBillingErrors, GetAdminAccountBillingResponses, GetAdminAskPageInsightsData, GetAdminAskPageInsightsErrors, GetAdminAskPageInsightsResponses, GetAdminDashboardStatsData, GetAdminDashboardStatsErrors, GetAdminDashboardStatsResponses, GetAdminModerationCaseData, GetAdminModerationCaseErrors, GetAdminModerationCaseResponses, GetAgencyHubGroupData, GetAgencyHubGroupErrors, GetAgencyHubGroupResponses, GetAgencyHubInfluencerDetailData, GetAgencyHubInfluencerDetailErrors, GetAgencyHubInfluencerDetailResponses, GetAllInfluencerPostsByDateData, GetAllInfluencerPostsByDateResponses, GetAllInfluencerPostsData, GetAllInfluencerPostsResponses, GetAllPostsForInfluencerData, GetAllPostsForInfluencerErrors, GetAllPostsForInfluencerResponses, GetApiTokenData, GetApiTokenErrors, GetApiTokenResponses, GetAppStatsData, GetAppStatsErrors, GetAppStatsResponses, GetArtifactData, GetArtifactErrors, GetArtifactResponses, GetAskPageInsightsData, GetAskPageInsightsErrors, GetAskPageInsightsResponses, GetAskPageInsightsVideosData, GetAskPageInsightsVideosErrors, GetAskPageInsightsVideosResponses, GetAskPageSettingsData, GetAskPageSettingsErrors, GetAskPageSettingsResponses, GetAuthProvidersData, GetAuthProvidersErrors, GetAuthProvidersResponses, GetAutoProcessData, GetAutoProcessResponses, GetBillingChargeReceiptData, GetBillingChargeReceiptErrors, GetBillingChargeReceiptResponses, GetBillingChargesData, GetBillingChargesResponses, GetBillingEventsData, GetBillingEventsResponses, GetBillingPlansData, GetBillingPlansResponses, GetBillingPortalSessionData, GetBillingPortalSessionErrors, GetBillingPortalSessionResponses, GetBillingTopupsData, GetBillingTopupsResponses, GetBoardClipData, GetBoardClipErrors, GetBoardClipResponses, GetBoardData, GetBoardErrors, GetBoardResponses, GetBoardsByVideoIdsData, GetBoardsByVideoIdsErrors, GetBoardsByVideoIdsResponses, GetBrowserSessionData, GetBrowserSessionErrors, GetChatCostsData, GetChatCostsErrors, GetChatCostsResponses, GetConnectedAccountData, GetConnectedAccountResponses, GetConnectedAccountsData, GetConnectedAccountsResponses, GetConnectedAccountsStatsData, GetConnectedAccountsStatsResponses, GetCurrentUserData, GetCurrentUserResponses, GetDefaultPublicPoolData, GetDefaultPublicPoolErrors, GetDefaultPublicPoolResponses, GetInfluencerData, GetInfluencerPoolData, GetInfluencerPoolErrors, GetInfluencerPoolResponses, GetInfluencerPublicProfileData, GetInfluencerPublicProfileErrors, GetInfluencerPublicProfileResponses, GetInfluencerResponses, GetKnockFeedAuthData, GetKnockFeedAuthResponses, GetLoadTestBatchData, GetLoadTestBatchErrors, GetLoadTestBatchResponses, GetMeteringBalanceData, GetMeteringBalanceErrors, GetMeteringBalanceResponses, GetMeteringGrantsData, GetMeteringGrantsErrors, GetMeteringGrantsResponses, GetMyAskPageQuestionsData, GetMyAskPageQuestionsResponses, GetMyAskPageSubscriptionsData, GetMyAskPageSubscriptionsResponses, GetMySubscriptionsData, GetMySubscriptionsResponses, GetPaymentMethodsData, GetPaymentMethodsResponses, GetPendingVideosData, GetPendingVideosResponses, GetPoolAnalysisCategoryData, GetPoolAnalysisCategoryErrors, GetPoolAnalysisCategoryResponses, GetPoolData, GetPoolErrors, GetPoolResponses, GetProcessingBatchData, GetProcessingBatchResponses, GetProjectData, GetProjectErrors, GetProjectQuestionData, GetProjectQuestionErrors, GetProjectQuestionResponses, GetProjectResponses, GetPublicAskPageInfluencerData, GetPublicAskPageInfluencerErrors, GetPublicAskPageInfluencerResponses, GetPublicBoardData, GetPublicBoardErrors, GetPublicBoardResponses, GetPublicPoolData, GetPublicPoolErrors, GetPublicPoolResponses, GetQuestionData, GetQuestionErrors, GetQuestionInteractionData, GetQuestionInteractionErrors, GetQuestionInteractionResponses, GetQuestionLibraryCountsData, GetQuestionLibraryCountsErrors, GetQuestionLibraryCountsResponses, GetQuestionLibraryData, GetQuestionLibraryResponses, GetQuestionResponses, GetRatingsData, GetRatingsErrors, GetRatingsResponses, GetRecentStudioPlaybookQuestionsData, GetRecentStudioPlaybookQuestionsResponses, GetSettingDefinitionData, GetSettingDefinitionErrors, GetSettingDefinitionResponses, GetSettingsChildrenData, GetSettingsChildrenErrors, GetSettingsChildrenResponses, GetSettingsSchemaData, GetSettingsSchemaErrors, GetSettingsSchemaResponses, GetSettingsValuesData, GetSettingsValuesErrors, GetSettingsValuesResponses, GetSocialChannelsInfoData, GetSocialChannelsInfoErrors, GetSocialChannelsInfoResponses, GetStudioDraftData, GetStudioDraftErrors, GetStudioDraftResponses, GetStudioVideoSuggestedQuestionsData, GetStudioVideoSuggestedQuestionsErrors, GetStudioVideoSuggestedQuestionsResponses, GetSubscriptionData, GetSubscriptionErrors, GetSubscriptionResponses, GetUploadSessionData, GetUploadSessionErrors, GetUploadSessionResponses, GetUserData, GetUserErrors, GetUserFeatureFlagsData, GetUserFeatureFlagsErrors, GetUserFeatureFlagsResponses, GetUserResponses, GetVideoByIdData, GetVideoByIdErrors, GetVideoByIdResponses, GetVideoCompletionProgressData, GetVideoCompletionProgressErrors, GetVideoCompletionProgressResponses, GetVideoData, GetVideoErrors, GetVideoPreviewsData, GetVideoPreviewsErrors, GetVideoPreviewsResponses, GetVideoResponses, GetVideoSampledFramesData, GetVideoSampledFramesErrors, GetVideoSampledFramesResponses, GrantAccountMeteringCreditData, GrantAccountMeteringCreditErrors, GrantAccountMeteringCreditResponses, HeadArtifactData, HeadArtifactErrors, HeadArtifactResponses, IgnorePostsData, IgnorePostsResponses, IgnoreProcessingBatchFailedData, IgnoreProcessingBatchFailedResponses, ImpersonateUserData, ImpersonateUserErrors, ImpersonateUserResponses, ImportInfluencersData, ImportInfluencersResponses, ImportLoadTestInfluencersData, ImportLoadTestInfluencersErrors, ImportLoadTestInfluencersResponses, InitUploadData, InitUploadErrors, InitUploadResponses, InviteAgencyHubInfluencerByEmailData, InviteAgencyHubInfluencerByEmailErrors, InviteAgencyHubInfluencerByEmailResponses, InviteAgencyHubInfluencerByHandleData, InviteAgencyHubInfluencerByHandleErrors, InviteAgencyHubInfluencerByHandleResponses, LeaveStudioAgencyData, LeaveStudioAgencyErrors, LeaveStudioAgencyResponses, LinkAccountBillingData, LinkAccountBillingErrors, LinkAccountBillingResponses, LinkAccountMeteringData, LinkAccountMeteringErrors, LinkAccountMeteringResponses, LinkStudioDraftData, LinkStudioDraftErrors, LinkStudioDraftResponses, ListAccountPlanOptionsData, ListAccountPlanOptionsErrors, ListAccountPlanOptionsResponses, ListAccountsData, ListAccountsResponses, ListAdminFaultedAccountsData, ListAdminFaultedAccountsResponses, ListAdminInfluencersData, ListAdminInfluencersResponses, ListAdminModerationCasesData, ListAdminModerationCasesResponses, ListAgenciesData, ListAgenciesResponses, ListAgencyHubGroupInfluencersData, ListAgencyHubGroupInfluencersErrors, ListAgencyHubGroupInfluencersResponses, ListAgencyHubGroupsData, ListAgencyHubGroupsErrors, ListAgencyHubGroupsResponses, ListAgencyHubInfluencersData, ListAgencyHubInfluencersErrors, ListAgencyHubInfluencersResponses, ListAgencyHubInfluencerStatsData, ListAgencyHubInfluencerStatsErrors, ListAgencyHubInfluencerStatsResponses, ListAgencyUsersData, ListAgencyUsersErrors, ListAgencyUsersResponses, ListArtifactFilesData, ListArtifactFilesErrors, ListArtifactFilesResponses, ListArtifactKindsData, ListArtifactKindsErrors, ListArtifactKindsResponses, ListArtifactsByQuestionData, ListArtifactsByQuestionErrors, ListArtifactsByQuestionResponses, ListArtifactsData, ListArtifactsErrors, ListArtifactsResponses, ListAskPagePostsData, ListAskPagePostsErrors, ListAskPagePostsResponses, ListAskPageSharesData, ListAskPageSharesResponses, ListBoardClipsData, ListBoardClipsErrors, ListBoardClipsResponses, ListBoardsData, ListBoardsErrors, ListBoardsResponses, ListCategoryGroupsData, ListCategoryGroupsResponses, ListDiscoveryCategoriesData, ListDiscoveryCategoriesResponses, ListDiscoveryCategoryCreatorsData, ListDiscoveryCategoryCreatorsResponses, ListDiscoveryCreatorsByCategoryData, ListDiscoveryCreatorsByCategoryResponses, ListDiscoverySuggestedInfluencersData, ListDiscoverySuggestedInfluencersResponses, ListFollowedBoardsData, ListFollowedBoardsErrors, ListFollowedBoardsResponses, ListLoadTestBatchesData, ListLoadTestBatchesErrors, ListLoadTestBatchesResponses, ListMyPoolsData, ListMyPoolsErrors, ListMyPoolsResponses, ListNotificationsData, ListNotificationsResponses, ListPoolAccountsData, ListPoolAccountsErrors, ListPoolAccountsResponses, ListPoolAnalysisCategoriesData, ListPoolAnalysisCategoriesErrors, ListPoolAnalysisCategoriesResponses, ListPoolConsentsData, ListPoolConsentsErrors, ListPoolConsentsResponses, ListProcessingBatchesData, ListProcessingBatchesResponses, ListProjectAnalysisData, ListProjectAnalysisErrors, ListProjectAnalysisResponses, ListProjectAudioData, ListProjectAudioErrors, ListProjectAudioResponses, ListProjectPoolsData, ListProjectPoolsErrors, ListProjectPoolsResponses, ListProjectQuestionsData, ListProjectQuestionsErrors, ListProjectQuestionsResponses, ListProjectsData, ListProjectsErrors, ListProjectSocialChannelsData, ListProjectSocialChannelsErrors, ListProjectSocialChannelsResponses, ListProjectSocialPostsData, ListProjectSocialPostsErrors, ListProjectSocialPostsResponses, ListProjectsResponses, ListProjectVideosData, ListProjectVideosErrors, ListProjectVideosResponses, ListProjectWorkflowsData, ListProjectWorkflowsErrors, ListProjectWorkflowsResponses, ListPublicBoardClipsData, ListPublicBoardClipsErrors, ListPublicBoardClipsResponses, ListPublicBoardsData, ListPublicBoardsErrors, ListPublicBoardsResponses, ListPublicPoolsData, ListPublicPoolsErrors, ListPublicPoolsResponses, ListQuestionEffortsData, ListQuestionEffortsErrors, ListQuestionEffortsResponses, ListQuestionLibrariesData, ListQuestionLibrariesResponses, ListStudioAgenciesData, ListStudioAgenciesResponses, ListStudioAgencyInvitesData, ListStudioAgencyInvitesResponses, ListStudioDraftLinkAllowedPlatformsData, ListStudioDraftLinkAllowedPlatformsErrors, ListStudioDraftLinkAllowedPlatformsResponses, ListStudioDraftQuestionsData, ListStudioDraftQuestionsErrors, ListStudioDraftQuestionsResponses, ListStudioDraftsData, ListStudioDraftsErrors, ListStudioDraftsResponses, ListUserAccountsData, ListUserAccountsResponses, ListUserCategoriesData, ListUserCategoriesResponses, ListUserQuestionsData, ListUserQuestionsErrors, ListUserQuestionsResponses, ListUsersData, ListUsersResponses, PatchAutoProcessData, PatchAutoProcessResponses, PatchInteractionData, PatchInteractionErrors, PatchInteractionResponses, PatchUserData, PatchUserResponses, PostInternalConnectedAccountsStatsNotifyData, PostInternalConnectedAccountsStatsNotifyErrors, PostInternalConnectedAccountsStatsNotifyResponses, PostInternalQuestionProgressData, PostInternalQuestionProgressErrors, PostInternalQuestionProgressResponses, PresignAskPageBannerUploadData, PresignAskPageBannerUploadErrors, PresignAskPageBannerUploadResponses, PreviewLoadTestCleanupData, PreviewLoadTestCleanupErrors, PreviewLoadTestCleanupResponses, PreviewSubscriptionChangeData, PreviewSubscriptionChangeErrors, PreviewSubscriptionChangeResponses, ProcessAccountsData, ProcessAccountsResponses, ProcessDirectUploadVideosData, ProcessDirectUploadVideosErrors, ProcessDirectUploadVideosResponses, ProcessSourceVideosData, ProcessSourceVideosResponses, ProcessStudioDraftData, ProcessStudioDraftErrors, ProcessStudioDraftResponses, ProcessVideosData, ProcessVideosErrors, ProcessVideosResponses, PromoteDiscoveredPostsData, PromoteDiscoveredPostsErrors, PromoteDiscoveredPostsResponses, PublishStudioDraftData, PublishStudioDraftErrors, PublishStudioDraftResponses, PurchaseAskPagePassData, PurchaseAskPagePassErrors, PurchaseAskPagePassResponses, PurchaseTopupData, PurchaseTopupErrors, PurchaseTopupResponses, RebuildAdminAskPageInsightsData, RebuildAdminAskPageInsightsErrors, RebuildAdminAskPageInsightsResponses, RebuildAllAdminAskPageInsightsData, RebuildAllAdminAskPageInsightsErrors, RebuildAllAdminAskPageInsightsResponses, RegisterAccountMeteringData, RegisterAccountMeteringErrors, RegisterAccountMeteringResponses, RegisterCompanionUploadData, RegisterCompanionUploadErrors, RegisterCompanionUploadResponses, ReleaseQuestionLibraryLockData, ReleaseQuestionLibraryLockResponses, RemoveAccountMemberData, RemoveAccountMemberErrors, RemoveAccountMemberResponses, RemoveAgencyHubGroupInfluencerData, RemoveAgencyHubGroupInfluencerErrors, RemoveAgencyHubGroupInfluencerResponses, RemoveAgencyUserData, RemoveAgencyUserErrors, RemoveAgencyUserResponses, RemoveAskPageInsightsBriefData, RemoveAskPageInsightsBriefErrors, RemoveAskPageInsightsBriefResponses, RemoveAskPagePostData, RemoveAskPagePostErrors, RemoveAskPagePostResponses, RemovePaymentMethodData, RemovePaymentMethodErrors, RemovePaymentMethodResponses, RenamePaymentMethodData, RenamePaymentMethodErrors, RenamePaymentMethodResponses, ReplaceUserCategoriesData, ReplaceUserCategoriesErrors, ReplaceUserCategoriesResponses, ReportVideoData, ReportVideoErrors, ReportVideoResponses, RequestUserDeletionData, RequestUserDeletionResponses, ResetSettingsData, ResetSettingsErrors, ResetSettingsResponses, ResolveAdminModerationCaseData, ResolveAdminModerationCaseErrors, ResolveAdminModerationCaseResponses, ResolveMentionsData, ResolveMentionsErrors, ResolveMentionsResponses, RespondToQuestionInputRequestData, RespondToQuestionInputRequestErrors, RespondToQuestionInputRequestResponses, RestoreAdminAskPageInsightsData, RestoreAdminAskPageInsightsErrors, RestoreAdminAskPageInsightsResponses, RestoreAgencyHubGroupData, RestoreAgencyHubGroupErrors, RestoreAgencyHubGroupResponses, RestoreBoardData, RestoreBoardErrors, RestoreBoardResponses, RestoreClipsData, RestoreClipsErrors, RestoreClipsResponses, RestoreQuestionLibraryData, RestoreQuestionLibraryResponses, ResumeSubscriptionData, ResumeSubscriptionErrors, ResumeSubscriptionResponses, RetryAdminFaultedAccountData, RetryAdminFaultedAccountErrors, RetryAdminFaultedAccountResponses, RevokeAgencyHubInfluencerInviteData, RevokeAgencyHubInfluencerInviteErrors, RevokeAgencyHubInfluencerInviteResponses, RevokeAskPageShareData, RevokeAskPageShareErrors, RevokeAskPageShareResponses, RevokeInfluencerData, RevokeInfluencerErrors, RevokeInfluencerResponses, SaveAskPageInsightsBriefData, SaveAskPageInsightsBriefErrors, SaveAskPageInsightsBriefResponses, SaveQuestionLibraryData, SaveQuestionLibraryResponses, SearchAgencyHubInfluencersData, SearchAgencyHubInfluencersResponses, SearchInfluencersData, SearchInfluencersErrors, SearchInfluencerSocialAccountsData, SearchInfluencerSocialAccountsErrors, SearchInfluencerSocialAccountsResponses, SearchInfluencersResponses, SearchPublicAskPageVideosData, SearchPublicAskPageVideosErrors, SearchPublicAskPageVideosResponses, SearchSocialChannelsData, SearchSocialChannelsErrors, SearchSocialChannelsResponses, SearchVideosData, SearchVideosErrors, SearchVideosResponses, SendAgencyHubInfluencerInviteReminderData, SendAgencyHubInfluencerInviteReminderErrors, SendAgencyHubInfluencerInviteReminderResponses, SetDefaultPaymentMethodData, SetDefaultPaymentMethodErrors, SetDefaultPaymentMethodResponses, SetPoolAccountEnabledData, SetPoolAccountEnabledErrors, SetPoolAccountEnabledResponses, SignOutData, SignOutErrors, SignOutResponses, SignUploadRequestData, SignUploadRequestErrors, SignUploadRequestResponses, StoreNotificationData, StoreNotificationErrors, StoreNotificationResponses, StreamPublicAskPageQuestionAnswerData, StreamPublicAskPageQuestionAnswerErrors, StreamPublicAskPageQuestionAnswerResponses, SubmitFeedbackData, SubmitFeedbackErrors, SubmitFeedbackResponses, SubscribeToAskGvtPlanData, SubscribeToAskGvtPlanErrors, SubscribeToAskGvtPlanResponses, SubscribeToAskPageData, SubscribeToAskPageErrors, SubscribeToAskPageResponses, SubscribeToFreeAskPageData, SubscribeToFreeAskPageErrors, SubscribeToFreeAskPageResponses, SubscribeToPlanData, SubscribeToPlanErrors, SubscribeToPlanResponses, SwitchCurrentAccountData, SwitchCurrentAccountErrors, SwitchCurrentAccountResponses, ToggleArtifactFavouriteData, ToggleArtifactFavouriteErrors, ToggleArtifactFavouriteResponses, UncoverAskPageInsightsBriefData, UncoverAskPageInsightsBriefErrors, UncoverAskPageInsightsBriefResponses, UndeleteQuestionData, UndeleteQuestionErrors, UndeleteQuestionResponses, UndeleteUserQuestionData, UndeleteUserQuestionErrors, UndeleteUserQuestionResponses, UnfollowBoardData, UnfollowBoardErrors, UnfollowBoardResponses, UnlinkAccountBillingData, UnlinkAccountBillingErrors, UnlinkAccountBillingResponses, UpdateAccountBillingData, UpdateAccountBillingErrors, UpdateAccountBillingResponses, UpdateAccountFeatureFlagData, UpdateAccountFeatureFlagErrors, UpdateAccountFeatureFlagResponses, UpdateAgencyData, UpdateAgencyErrors, UpdateAgencyHubGroupData, UpdateAgencyHubGroupErrors, UpdateAgencyHubGroupResponses, UpdateAgencyResponses, UpdateAskPageSettingsData, UpdateAskPageSettingsErrors, UpdateAskPageSettingsResponses, UpdateAskPageShareData, UpdateAskPageShareErrors, UpdateAskPageShareResponses, UpdateBoardClipData, UpdateBoardClipErrors, UpdateBoardClipResponses, UpdateBoardData, UpdateBoardErrors, UpdateBoardResponses, UpdateInfluencerData, UpdateInfluencerResponses, UpdatePoolAnalysisCategoryData, UpdatePoolAnalysisCategoryErrors, UpdatePoolAnalysisCategoryResponses, UpdatePoolData, UpdatePoolErrors, UpdatePoolResponses, UpdateProjectData, UpdateProjectErrors, UpdateProjectResponses, UpdatePublicPoolData, UpdatePublicPoolErrors, UpdatePublicPoolResponses, UpdateQuestionLibraryTileData, UpdateQuestionLibraryTileResponses, UpdateSettingsData, UpdateSettingsErrors, UpdateSettingsResponses, UpdateUserData, UpdateUserErrors, UpdateUserFeatureFlagsData, UpdateUserFeatureFlagsErrors, UpdateUserFeatureFlagsResponses, UpdateUserResponses, UploadAskPageBannerData, UploadAskPageBannerErrors, UploadAskPageBannerResponses, VerifyConnectedAccountNowData, VerifyConnectedAccountNowErrors, VerifyConnectedAccountNowResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Get Stripe customer details for the current user's account
 */
export const getAccountBilling = <ThrowOnError extends boolean = false>(options?: Options<GetAccountBillingData, ThrowOnError>): RequestResult<GetAccountBillingResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetAccountBillingResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/accounts/billing',
    ...options
});

/**
 * Update Stripe customer details for the current user's account
 */
export const updateAccountBilling = <ThrowOnError extends boolean = false>(options: Options<UpdateAccountBillingData, ThrowOnError>): RequestResult<UpdateAccountBillingResponses, UpdateAccountBillingErrors, ThrowOnError> => (options.client ?? client).patch<UpdateAccountBillingResponses, UpdateAccountBillingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/accounts/billing',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a Stripe Customer Portal URL for the current user's account
 */
export const getBillingPortalSession = <ThrowOnError extends boolean = false>(options?: Options<GetBillingPortalSessionData, ThrowOnError>): RequestResult<GetBillingPortalSessionResponses, GetBillingPortalSessionErrors, ThrowOnError> => (options?.client ?? client).get<GetBillingPortalSessionResponses, GetBillingPortalSessionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/accounts/billing/portal-session',
    ...options
});

/**
 * Create a Stripe SetupIntent for collecting a card in the browser
 */
export const createCardSetupIntent = <ThrowOnError extends boolean = false>(options?: Options<CreateCardSetupIntentData, ThrowOnError>): RequestResult<CreateCardSetupIntentResponses, CreateCardSetupIntentErrors, ThrowOnError> => (options?.client ?? client).post<CreateCardSetupIntentResponses, CreateCardSetupIntentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/accounts/billing/setup-intent',
    ...options
});

/**
 * Get payment methods for the current user's account
 */
export const getPaymentMethods = <ThrowOnError extends boolean = false>(options?: Options<GetPaymentMethodsData, ThrowOnError>): RequestResult<GetPaymentMethodsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetPaymentMethodsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/accounts/billing/payment-methods',
    ...options
});

/**
 * Store a card that has just been confirmed in the browser
 */
export const addPaymentMethod = <ThrowOnError extends boolean = false>(options: Options<AddPaymentMethodData, ThrowOnError>): RequestResult<AddPaymentMethodResponses, AddPaymentMethodErrors, ThrowOnError> => (options.client ?? client).post<AddPaymentMethodResponses, AddPaymentMethodErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/accounts/billing/payment-methods',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Make a stored card the default payment method
 */
export const setDefaultPaymentMethod = <ThrowOnError extends boolean = false>(options: Options<SetDefaultPaymentMethodData, ThrowOnError>): RequestResult<SetDefaultPaymentMethodResponses, SetDefaultPaymentMethodErrors, ThrowOnError> => (options.client ?? client).patch<SetDefaultPaymentMethodResponses, SetDefaultPaymentMethodErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/accounts/billing/payment-methods/{payment_method_id}/default',
    ...options
});

/**
 * Detach a stored card from the account's Stripe customer
 */
export const removePaymentMethod = <ThrowOnError extends boolean = false>(options: Options<RemovePaymentMethodData, ThrowOnError>): RequestResult<RemovePaymentMethodResponses, RemovePaymentMethodErrors, ThrowOnError> => (options.client ?? client).delete<RemovePaymentMethodResponses, RemovePaymentMethodErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/accounts/billing/payment-methods/{payment_method_id}',
    ...options
});

/**
 * Set or clear a stored card's nickname
 */
export const renamePaymentMethod = <ThrowOnError extends boolean = false>(options: Options<RenamePaymentMethodData, ThrowOnError>): RequestResult<RenamePaymentMethodResponses, RenamePaymentMethodErrors, ThrowOnError> => (options.client ?? client).patch<RenamePaymentMethodResponses, RenamePaymentMethodErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/accounts/billing/payment-methods/{payment_method_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get the current account's recent charges, from every merchant
 */
export const getBillingCharges = <ThrowOnError extends boolean = false>(options?: Options<GetBillingChargesData, ThrowOnError>): RequestResult<GetBillingChargesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetBillingChargesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/accounts/billing/charges',
    ...options
});

/**
 * Get a download link for a charge's receipt
 */
export const getBillingChargeReceipt = <ThrowOnError extends boolean = false>(options: Options<GetBillingChargeReceiptData, ThrowOnError>): RequestResult<GetBillingChargeReceiptResponses, GetBillingChargeReceiptErrors, ThrowOnError> => (options.client ?? client).get<GetBillingChargeReceiptResponses, GetBillingChargeReceiptErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/accounts/billing/charges/{charge_id}/receipt',
    ...options
});

/**
 * Get Stripe events for the current user's account
 */
export const getBillingEvents = <ThrowOnError extends boolean = false>(options?: Options<GetBillingEventsData, ThrowOnError>): RequestResult<GetBillingEventsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetBillingEventsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/accounts/billing/events',
    ...options
});

/**
 * List all accounts (admin only)
 */
export const listAccounts = <ThrowOnError extends boolean = false>(options?: Options<ListAccountsData, ThrowOnError>): RequestResult<ListAccountsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListAccountsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/accounts',
    ...options
});

/**
 * Create a new account (admin only)
 */
export const createAccount = <ThrowOnError extends boolean = false>(options: Options<CreateAccountData, ThrowOnError>): RequestResult<CreateAccountResponses, CreateAccountErrors, ThrowOnError> => (options.client ?? client).post<CreateAccountResponses, CreateAccountErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/accounts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get account-scoped feature flags and their state (admin only)
 */
export const getAccountFeatureFlags = <ThrowOnError extends boolean = false>(options: Options<GetAccountFeatureFlagsData, ThrowOnError>): RequestResult<GetAccountFeatureFlagsResponses, GetAccountFeatureFlagsErrors, ThrowOnError> => (options.client ?? client).get<GetAccountFeatureFlagsResponses, GetAccountFeatureFlagsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/accounts/{account_id}/feature-flags',
    ...options
});

/**
 * Set one account feature flag's state (admin only)
 */
export const updateAccountFeatureFlag = <ThrowOnError extends boolean = false>(options: Options<UpdateAccountFeatureFlagData, ThrowOnError>): RequestResult<UpdateAccountFeatureFlagResponses, UpdateAccountFeatureFlagErrors, ThrowOnError> => (options.client ?? client).patch<UpdateAccountFeatureFlagResponses, UpdateAccountFeatureFlagErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/accounts/{account_id}/feature-flags',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a single account by public ID (admin only)
 */
export const getAccount = <ThrowOnError extends boolean = false>(options: Options<GetAccountData, ThrowOnError>): RequestResult<GetAccountResponses, GetAccountErrors, ThrowOnError> => (options.client ?? client).get<GetAccountResponses, GetAccountErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/accounts/{account_id}',
    ...options
});

/**
 * Add a member to an account (admin only)
 */
export const addAccountMember = <ThrowOnError extends boolean = false>(options: Options<AddAccountMemberData, ThrowOnError>): RequestResult<AddAccountMemberResponses, AddAccountMemberErrors, ThrowOnError> => (options.client ?? client).post<AddAccountMemberResponses, AddAccountMemberErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/accounts/{account_id}/members',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove a member from an account (admin only)
 */
export const removeAccountMember = <ThrowOnError extends boolean = false>(options: Options<RemoveAccountMemberData, ThrowOnError>): RequestResult<RemoveAccountMemberResponses, RemoveAccountMemberErrors, ThrowOnError> => (options.client ?? client).delete<RemoveAccountMemberResponses, RemoveAccountMemberErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/accounts/{account_id}/members/{user_id}',
    ...options
});

/**
 * Unlink the Stripe customer ID from an account (admin only)
 */
export const unlinkAccountBilling = <ThrowOnError extends boolean = false>(options: Options<UnlinkAccountBillingData, ThrowOnError>): RequestResult<UnlinkAccountBillingResponses, UnlinkAccountBillingErrors, ThrowOnError> => (options.client ?? client).delete<UnlinkAccountBillingResponses, UnlinkAccountBillingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/accounts/{account_id}/billing',
    ...options
});

/**
 * Get Stripe customer details for an account (admin only)
 */
export const getAdminAccountBilling = <ThrowOnError extends boolean = false>(options: Options<GetAdminAccountBillingData, ThrowOnError>): RequestResult<GetAdminAccountBillingResponses, GetAdminAccountBillingErrors, ThrowOnError> => (options.client ?? client).get<GetAdminAccountBillingResponses, GetAdminAccountBillingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/accounts/{account_id}/billing',
    ...options
});

/**
 * Create a Stripe customer for an account (admin only)
 */
export const createAccountBilling = <ThrowOnError extends boolean = false>(options: Options<CreateAccountBillingData, ThrowOnError>): RequestResult<CreateAccountBillingResponses, CreateAccountBillingErrors, ThrowOnError> => (options.client ?? client).post<CreateAccountBillingResponses, CreateAccountBillingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/accounts/{account_id}/billing',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Link a Stripe customer ID to an account (admin only)
 */
export const linkAccountBilling = <ThrowOnError extends boolean = false>(options: Options<LinkAccountBillingData, ThrowOnError>): RequestResult<LinkAccountBillingResponses, LinkAccountBillingErrors, ThrowOnError> => (options.client ?? client).put<LinkAccountBillingResponses, LinkAccountBillingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/accounts/{account_id}/billing',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Stripe payment methods for an account (admin only)
 */
export const getAccountBillingPaymentMethods = <ThrowOnError extends boolean = false>(options: Options<GetAccountBillingPaymentMethodsData, ThrowOnError>): RequestResult<GetAccountBillingPaymentMethodsResponses, GetAccountBillingPaymentMethodsErrors, ThrowOnError> => (options.client ?? client).get<GetAccountBillingPaymentMethodsResponses, GetAccountBillingPaymentMethodsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/accounts/{account_id}/billing/payment-methods',
    ...options
});

/**
 * Get an account's recent charges, from every merchant (admin only)
 */
export const getAccountBillingCharges = <ThrowOnError extends boolean = false>(options: Options<GetAccountBillingChargesData, ThrowOnError>): RequestResult<GetAccountBillingChargesResponses, GetAccountBillingChargesErrors, ThrowOnError> => (options.client ?? client).get<GetAccountBillingChargesResponses, GetAccountBillingChargesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/accounts/{account_id}/billing/charges',
    ...options
});

/**
 * Get a download link for one of an account's charge receipts (admin only)
 */
export const getAccountBillingChargeReceipt = <ThrowOnError extends boolean = false>(options: Options<GetAccountBillingChargeReceiptData, ThrowOnError>): RequestResult<GetAccountBillingChargeReceiptResponses, GetAccountBillingChargeReceiptErrors, ThrowOnError> => (options.client ?? client).get<GetAccountBillingChargeReceiptResponses, GetAccountBillingChargeReceiptErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/accounts/{account_id}/billing/charges/{charge_id}/receipt',
    ...options
});

/**
 * Register an account with the metering service (admin only)
 */
export const registerAccountMetering = <ThrowOnError extends boolean = false>(options: Options<RegisterAccountMeteringData, ThrowOnError>): RequestResult<RegisterAccountMeteringResponses, RegisterAccountMeteringErrors, ThrowOnError> => (options.client ?? client).post<RegisterAccountMeteringResponses, RegisterAccountMeteringErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/accounts/{account_id}/metering',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Link an existing metering customer ID to an account (admin only)
 */
export const linkAccountMetering = <ThrowOnError extends boolean = false>(options: Options<LinkAccountMeteringData, ThrowOnError>): RequestResult<LinkAccountMeteringResponses, LinkAccountMeteringErrors, ThrowOnError> => (options.client ?? client).put<LinkAccountMeteringResponses, LinkAccountMeteringErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/accounts/{account_id}/metering',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List the catalogue plans an account can be registered or moved onto (admin only)
 */
export const listAccountPlanOptions = <ThrowOnError extends boolean = false>(options: Options<ListAccountPlanOptionsData, ThrowOnError>): RequestResult<ListAccountPlanOptionsResponses, ListAccountPlanOptionsErrors, ThrowOnError> => (options.client ?? client).get<ListAccountPlanOptionsResponses, ListAccountPlanOptionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/accounts/{account_id}/plans',
    ...options
});

/**
 * Get an account's metering balance (admin only)
 */
export const getAccountMeteringBalance = <ThrowOnError extends boolean = false>(options: Options<GetAccountMeteringBalanceData, ThrowOnError>): RequestResult<GetAccountMeteringBalanceResponses, GetAccountMeteringBalanceErrors, ThrowOnError> => (options.client ?? client).get<GetAccountMeteringBalanceResponses, GetAccountMeteringBalanceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/accounts/{account_id}/metering/balance',
    ...options
});

/**
 * Itemise the grants behind an account's metering balance (admin only)
 */
export const getAccountMeteringGrants = <ThrowOnError extends boolean = false>(options: Options<GetAccountMeteringGrantsData, ThrowOnError>): RequestResult<GetAccountMeteringGrantsResponses, GetAccountMeteringGrantsErrors, ThrowOnError> => (options.client ?? client).get<GetAccountMeteringGrantsResponses, GetAccountMeteringGrantsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/accounts/{account_id}/metering/grants',
    ...options
});

/**
 * Get an account's daily metering consumption for the last seven days (admin only)
 */
export const getAccountMeteringUsage = <ThrowOnError extends boolean = false>(options: Options<GetAccountMeteringUsageData, ThrowOnError>): RequestResult<GetAccountMeteringUsageResponses, GetAccountMeteringUsageErrors, ThrowOnError> => (options.client ?? client).get<GetAccountMeteringUsageResponses, GetAccountMeteringUsageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/accounts/{account_id}/metering/usage',
    ...options
});

/**
 * Grant an account credits or VIUs without a purchase (admin only)
 *
 * Puts units into an account by hand and records a `topup_orders` row for it, with the acting admin and the reason on it. Nothing is charged, nobody is notified, and the balance is in place before this returns.
 */
export const grantAccountMeteringCredit = <ThrowOnError extends boolean = false>(options: Options<GrantAccountMeteringCreditData, ThrowOnError>): RequestResult<GrantAccountMeteringCreditResponses, GrantAccountMeteringCreditErrors, ThrowOnError> => (options.client ?? client).post<GrantAccountMeteringCreditResponses, GrantAccountMeteringCreditErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/accounts/{account_id}/metering/credits',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Read the plan an account is on, and the plans it can be moved to (admin only)
 *
 * Composes what metering says the account is on, its live subscription if it has one, and the catalogue to choose from. A subscription that is not comped means the plan cannot be changed here: what the account is on is decided by what it is being billed for.
 */
export const getAccountMeteringPlan = <ThrowOnError extends boolean = false>(options: Options<GetAccountMeteringPlanData, ThrowOnError>): RequestResult<GetAccountMeteringPlanResponses, GetAccountMeteringPlanErrors, ThrowOnError> => (options.client ?? client).get<GetAccountMeteringPlanResponses, GetAccountMeteringPlanErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/accounts/{account_id}/metering/plan',
    ...options
});

/**
 * Move an account onto a different plan (admin only)
 *
 * Moves the account onto a catalogue plan, AskGVT or Studio. REFUSED WITH 409 FOR ANY ACCOUNT WITH A LIVE SUBSCRIPTION THAT IS NOT COMPED: a billed account's plan is decided by what it is being charged for, and an override would be undone by the next sync from the merchant. This is for accounts nobody is billing - comp, internal and free accounts - and nothing is charged or refunded. The move grants the plan's monthly allowance afresh, and grants the plan's onboarding VIUs on a move up into a plan not granted before, unless onboarding_vius overrides that.
 */
export const changeAccountPlan = <ThrowOnError extends boolean = false>(options: Options<ChangeAccountPlanData, ThrowOnError>): RequestResult<ChangeAccountPlanResponses, ChangeAccountPlanErrors, ThrowOnError> => (options.client ?? client).put<ChangeAccountPlanResponses, ChangeAccountPlanErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/accounts/{account_id}/metering/plan',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Move an account onto a custom plan (admin only)
 *
 * Moves an account onto a plan built from the allowances given here rather than a catalogue plan, recorded as a comp with plan_id 'custom'. Refused for the same reasons as a catalogue plan change. Every call starts a new contract and grants its monthly allowance, even when the allowances match the current custom plan, and grants onboarding_vius when positive.
 */
export const changeAccountToCustomPlan = <ThrowOnError extends boolean = false>(options: Options<ChangeAccountToCustomPlanData, ThrowOnError>): RequestResult<ChangeAccountToCustomPlanResponses, ChangeAccountToCustomPlanErrors, ThrowOnError> => (options.client ?? client).put<ChangeAccountToCustomPlanResponses, ChangeAccountToCustomPlanErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/accounts/{account_id}/metering/custom-plan',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List agencies (admin roster)
 */
export const listAgencies = <ThrowOnError extends boolean = false>(options?: Options<ListAgenciesData, ThrowOnError>): RequestResult<ListAgenciesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListAgenciesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agencies',
    ...options
});

/**
 * Create an agency (admin roster)
 */
export const createAgency = <ThrowOnError extends boolean = false>(options: Options<CreateAgencyData, ThrowOnError>): RequestResult<CreateAgencyResponses, CreateAgencyErrors, ThrowOnError> => (options.client ?? client).post<CreateAgencyResponses, CreateAgencyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agencies',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete an agency (admin roster)
 */
export const deleteAgency = <ThrowOnError extends boolean = false>(options: Options<DeleteAgencyData, ThrowOnError>): RequestResult<DeleteAgencyResponses, DeleteAgencyErrors, ThrowOnError> => (options.client ?? client).delete<DeleteAgencyResponses, DeleteAgencyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agencies/{agency_id}',
    ...options
});

/**
 * Update an agency (admin roster)
 */
export const updateAgency = <ThrowOnError extends boolean = false>(options: Options<UpdateAgencyData, ThrowOnError>): RequestResult<UpdateAgencyResponses, UpdateAgencyErrors, ThrowOnError> => (options.client ?? client).patch<UpdateAgencyResponses, UpdateAgencyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agencies/{agency_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List users assigned to an agency
 */
export const listAgencyUsers = <ThrowOnError extends boolean = false>(options: Options<ListAgencyUsersData, ThrowOnError>): RequestResult<ListAgencyUsersResponses, ListAgencyUsersErrors, ThrowOnError> => (options.client ?? client).get<ListAgencyUsersResponses, ListAgencyUsersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agencies/{agency_id}/users',
    ...options
});

/**
 * Add a user to an agency
 */
export const addAgencyUser = <ThrowOnError extends boolean = false>(options: Options<AddAgencyUserData, ThrowOnError>): RequestResult<AddAgencyUserResponses, AddAgencyUserErrors, ThrowOnError> => (options.client ?? client).post<AddAgencyUserResponses, AddAgencyUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agencies/{agency_id}/users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove a user from an agency
 */
export const removeAgencyUser = <ThrowOnError extends boolean = false>(options: Options<RemoveAgencyUserData, ThrowOnError>): RequestResult<RemoveAgencyUserResponses, RemoveAgencyUserErrors, ThrowOnError> => (options.client ?? client).delete<RemoveAgencyUserResponses, RemoveAgencyUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agencies/{agency_id}/users/{user_id}',
    ...options
});

/**
 * Where a creator's Audience Insights are
 */
export const getAdminAskPageInsights = <ThrowOnError extends boolean = false>(options: Options<GetAdminAskPageInsightsData, ThrowOnError>): RequestResult<GetAdminAskPageInsightsResponses, GetAdminAskPageInsightsErrors, ThrowOnError> => (options.client ?? client).get<GetAdminAskPageInsightsResponses, GetAdminAskPageInsightsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/influencers/{influencer_id}/insights',
    ...options
});

/**
 * Rebuild a creator's Audience Insights
 *
 * Restarts a rebuild already under way. The creator keeps their current report until the new one is complete.
 */
export const rebuildAdminAskPageInsights = <ThrowOnError extends boolean = false>(options: Options<RebuildAdminAskPageInsightsData, ThrowOnError>): RequestResult<RebuildAdminAskPageInsightsResponses, RebuildAdminAskPageInsightsErrors, ThrowOnError> => (options.client ?? client).post<RebuildAdminAskPageInsightsResponses, RebuildAdminAskPageInsightsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/influencers/{influencer_id}/insights/rebuild',
    ...options
});

/**
 * Switch a creator's Audience Insights back to the previous generation
 */
export const restoreAdminAskPageInsights = <ThrowOnError extends boolean = false>(options: Options<RestoreAdminAskPageInsightsData, ThrowOnError>): RequestResult<RestoreAdminAskPageInsightsResponses, RestoreAdminAskPageInsightsErrors, ThrowOnError> => (options.client ?? client).post<RestoreAdminAskPageInsightsResponses, RestoreAdminAskPageInsightsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/influencers/{influencer_id}/insights/restore',
    ...options
});

/**
 * Give up a creator's rebuild under way
 *
 * For a rebuild that keeps failing: frees its slot. The creator keeps their current report.
 */
export const cancelAdminAskPageInsightsRebuild = <ThrowOnError extends boolean = false>(options: Options<CancelAdminAskPageInsightsRebuildData, ThrowOnError>): RequestResult<CancelAdminAskPageInsightsRebuildResponses, CancelAdminAskPageInsightsRebuildErrors, ThrowOnError> => (options.client ?? client).post<CancelAdminAskPageInsightsRebuildResponses, CancelAdminAskPageInsightsRebuildErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/influencers/{influencer_id}/insights/cancel',
    ...options
});

/**
 * What rebuilding every creator's Audience Insights would cost
 */
export const estimateAdminAskPageInsightsRebuildAll = <ThrowOnError extends boolean = false>(options?: Options<EstimateAdminAskPageInsightsRebuildAllData, ThrowOnError>): RequestResult<EstimateAdminAskPageInsightsRebuildAllResponses, EstimateAdminAskPageInsightsRebuildAllErrors, ThrowOnError> => (options?.client ?? client).get<EstimateAdminAskPageInsightsRebuildAllResponses, EstimateAdminAskPageInsightsRebuildAllErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/ask-page-insights/rebuild-all',
    ...options
});

/**
 * Rebuild every creator's Audience Insights
 *
 * A few run at a time; each creator keeps their current report until their rebuild completes. Rebuilds already under way are left to finish.
 */
export const rebuildAllAdminAskPageInsights = <ThrowOnError extends boolean = false>(options: Options<RebuildAllAdminAskPageInsightsData, ThrowOnError>): RequestResult<RebuildAllAdminAskPageInsightsResponses, RebuildAllAdminAskPageInsightsErrors, ThrowOnError> => (options.client ?? client).post<RebuildAllAdminAskPageInsightsResponses, RebuildAllAdminAskPageInsightsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/ask-page-insights/rebuild-all',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List social accounts carrying a durable collection fault (admin only)
 */
export const listAdminFaultedAccounts = <ThrowOnError extends boolean = false>(options?: Options<ListAdminFaultedAccountsData, ThrowOnError>): RequestResult<ListAdminFaultedAccountsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListAdminFaultedAccountsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/faulted-accounts',
    ...options
});

/**
 * Point a faulted account at a new handle and clear its fault (admin only)
 *
 * Updates the handle, rebuilds profile_url and clears the fault columns in one step. The caller is responsible for having confirmed the handle belongs to this account: a name match alone picks wrong accounts.
 */
export const applyAdminFaultedAccountHandle = <ThrowOnError extends boolean = false>(options: Options<ApplyAdminFaultedAccountHandleData, ThrowOnError>): RequestResult<ApplyAdminFaultedAccountHandleResponses, ApplyAdminFaultedAccountHandleErrors, ThrowOnError> => (options.client ?? client).post<ApplyAdminFaultedAccountHandleResponses, ApplyAdminFaultedAccountHandleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/faulted-accounts/{social_account_id}/apply-handle',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Stop collecting a faulted account whose handle cannot be recovered (admin only)
 *
 * Disables the account in every pool, which stops post-collector collecting it, and clears its fault. Posts already collected are kept.
 */
export const disableAdminFaultedAccount = <ThrowOnError extends boolean = false>(options: Options<DisableAdminFaultedAccountData, ThrowOnError>): RequestResult<DisableAdminFaultedAccountResponses, DisableAdminFaultedAccountErrors, ThrowOnError> => (options.client ?? client).post<DisableAdminFaultedAccountResponses, DisableAdminFaultedAccountErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/faulted-accounts/{social_account_id}/disable',
    ...options
});

/**
 * Run collection for a faulted account now (admin only)
 *
 * Triggers a collection run so the recorded fault can be re-confirmed against the platform. Does not clear the fault: a successful run does that on its own.
 */
export const retryAdminFaultedAccount = <ThrowOnError extends boolean = false>(options: Options<RetryAdminFaultedAccountData, ThrowOnError>): RequestResult<RetryAdminFaultedAccountResponses, RetryAdminFaultedAccountErrors, ThrowOnError> => (options.client ?? client).post<RetryAdminFaultedAccountResponses, RetryAdminFaultedAccountErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/faulted-accounts/{social_account_id}/retry',
    ...options
});

/**
 * List all influencers (admin only)
 */
export const listAdminInfluencers = <ThrowOnError extends boolean = false>(options?: Options<ListAdminInfluencersData, ThrowOnError>): RequestResult<ListAdminInfluencersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListAdminInfluencersResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/influencers',
    ...options
});

/**
 * Get all posts for an influencer
 */
export const getAllPostsForInfluencer = <ThrowOnError extends boolean = false>(options: Options<GetAllPostsForInfluencerData, ThrowOnError>): RequestResult<GetAllPostsForInfluencerResponses, GetAllPostsForInfluencerErrors, ThrowOnError> => (options.client ?? client).get<GetAllPostsForInfluencerResponses, GetAllPostsForInfluencerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/influencers/{influencer_id}/all_posts',
    ...options
});

/**
 * Propose an influencer for a public pool
 *
 * Proposes the influencer for the given public pool, pending the influencer's own accept/decline (see /api/pool-consents). No backfill runs until they accept. An influencer may hold independent proposals/consents for several pools at once.
 */
export const approveInfluencer = <ThrowOnError extends boolean = false>(options: Options<ApproveInfluencerData, ThrowOnError>): RequestResult<ApproveInfluencerResponses, ApproveInfluencerErrors, ThrowOnError> => (options.client ?? client).post<ApproveInfluencerResponses, ApproveInfluencerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/influencers/{influencer_id}/approve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Re-run the public pool backfill for a consented influencer
 *
 * Starts a backfill workflow that replicates the influencer's processed content into the given public pool (Postgres + Qdrant), for a pool the influencer has already accepted. Re-runnable: existing target-pool Qdrant points are cleared first so re-runs do not duplicate. Optionally also purges stale copies from other public pools (e.g. the default public pool).
 */
export const backfillInfluencer = <ThrowOnError extends boolean = false>(options: Options<BackfillInfluencerData, ThrowOnError>): RequestResult<BackfillInfluencerResponses, BackfillInfluencerErrors, ThrowOnError> => (options.client ?? client).post<BackfillInfluencerResponses, BackfillInfluencerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/influencers/{influencer_id}/backfill',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke an influencer's consent for a public pool
 *
 * Revokes the influencer's proposed or accepted consent for the given pool and starts a purge workflow to remove replicated content from it. Other pools the influencer has consented to are unaffected.
 */
export const revokeInfluencer = <ThrowOnError extends boolean = false>(options: Options<RevokeInfluencerData, ThrowOnError>): RequestResult<RevokeInfluencerResponses, RevokeInfluencerErrors, ThrowOnError> => (options.client ?? client).post<RevokeInfluencerResponses, RevokeInfluencerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/influencers/{influencer_id}/revoke',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Permanently delete an influencer and all their connected social accounts and data
 *
 * Starts a deletion workflow that removes every social account the influencer holds a verification claim on (and their posts, videos, S3 objects and Qdrant vectors), the influencer's private pool, and the influencer record itself. Optionally also deletes the influencer's linked user login.
 */
export const deleteInfluencer = <ThrowOnError extends boolean = false>(options: Options<DeleteInfluencerData, ThrowOnError>): RequestResult<DeleteInfluencerResponses, DeleteInfluencerErrors, ThrowOnError> => (options.client ?? client).delete<DeleteInfluencerResponses, DeleteInfluencerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/influencers/{influencer_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Import influencers from a JSON file
 *
 * Creates an influencer, a private pool and a user that never signs in for each entry, under the JSON name as given. Each user gets its own account on the entry's plan (Plus when omitted), which its collection bills. Collects each account's newest posts without processing them. Names that already belong to an influencer are skipped.
 */
export const importInfluencers = <ThrowOnError extends boolean = false>(options: Options<ImportInfluencersData, ThrowOnError>): RequestResult<ImportInfluencersResponses, unknown, ThrowOnError> => (options.client ?? client).post<ImportInfluencersResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/influencers/import',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Import load-test influencers from a JSON file
 *
 * Creates a prefixed influencer, a private pool and a user that never signs in for each entry, billed to the importing admin's account, and collects each account's newest posts. Names that already belong to an influencer are skipped.
 */
export const importLoadTestInfluencers = <ThrowOnError extends boolean = false>(options: Options<ImportLoadTestInfluencersData, ThrowOnError>): RequestResult<ImportLoadTestInfluencersResponses, ImportLoadTestInfluencersErrors, ThrowOnError> => (options.client ?? client).post<ImportLoadTestInfluencersResponses, ImportLoadTestInfluencersErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/load-testing/import',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * List load-test import batches, newest first
 */
export const listLoadTestBatches = <ThrowOnError extends boolean = false>(options?: Options<ListLoadTestBatchesData, ThrowOnError>): RequestResult<ListLoadTestBatchesResponses, ListLoadTestBatchesErrors, ThrowOnError> => (options?.client ?? client).get<ListLoadTestBatchesResponses, ListLoadTestBatchesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/load-testing/batches',
    ...options
});

/**
 * Delete a load-test batch's users, influencers, pools and content
 *
 * Starts a deletion workflow. Channels an influencer outside the batch still claims keep their content.
 */
export const deleteLoadTestBatch = <ThrowOnError extends boolean = false>(options: Options<DeleteLoadTestBatchData, ThrowOnError>): RequestResult<DeleteLoadTestBatchResponses, DeleteLoadTestBatchErrors, ThrowOnError> => (options.client ?? client).delete<DeleteLoadTestBatchResponses, DeleteLoadTestBatchErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/load-testing/batches/{batch}',
    ...options
});

/**
 * List a load-test batch's users and influencers
 */
export const getLoadTestBatch = <ThrowOnError extends boolean = false>(options: Options<GetLoadTestBatchData, ThrowOnError>): RequestResult<GetLoadTestBatchResponses, GetLoadTestBatchErrors, ThrowOnError> => (options.client ?? client).get<GetLoadTestBatchResponses, GetLoadTestBatchErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/load-testing/batches/{batch}',
    ...options
});

/**
 * Count what deleting a load-test batch would remove
 */
export const previewLoadTestCleanup = <ThrowOnError extends boolean = false>(options: Options<PreviewLoadTestCleanupData, ThrowOnError>): RequestResult<PreviewLoadTestCleanupResponses, PreviewLoadTestCleanupErrors, ThrowOnError> => (options.client ?? client).get<PreviewLoadTestCleanupResponses, PreviewLoadTestCleanupErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/load-testing/batches/{batch}/cleanup',
    ...options
});

/**
 * List video moderation cases (admin only)
 */
export const listAdminModerationCases = <ThrowOnError extends boolean = false>(options?: Options<ListAdminModerationCasesData, ThrowOnError>): RequestResult<ListAdminModerationCasesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListAdminModerationCasesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/moderation/cases',
    ...options
});

/**
 * One moderation case with its reports and the moments to review (admin only)
 *
 * The gate's scores are not returned: reviewers rule before seeing the model's confidence.
 */
export const getAdminModerationCase = <ThrowOnError extends boolean = false>(options: Options<GetAdminModerationCaseData, ThrowOnError>): RequestResult<GetAdminModerationCaseResponses, GetAdminModerationCaseErrors, ThrowOnError> => (options.client ?? client).get<GetAdminModerationCaseResponses, GetAdminModerationCaseErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/moderation/cases/{case_id}',
    ...options
});

/**
 * Rule on a moderation case (admin only)
 *
 * A held video is released or rejected; a reported video is taken down or dismissed.
 */
export const resolveAdminModerationCase = <ThrowOnError extends boolean = false>(options: Options<ResolveAdminModerationCaseData, ThrowOnError>): RequestResult<ResolveAdminModerationCaseResponses, ResolveAdminModerationCaseErrors, ThrowOnError> => (options.client ?? client).post<ResolveAdminModerationCaseResponses, ResolveAdminModerationCaseErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/moderation/cases/{case_id}/resolve',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List question library versions (admin)
 */
export const listQuestionLibraries = <ThrowOnError extends boolean = false>(options?: Options<ListQuestionLibrariesData, ThrowOnError>): RequestResult<ListQuestionLibrariesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListQuestionLibrariesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/question-libraries',
    ...options
});

/**
 * Create a question library version (admin)
 */
export const createQuestionLibrary = <ThrowOnError extends boolean = false>(options: Options<CreateQuestionLibraryData, ThrowOnError>): RequestResult<CreateQuestionLibraryResponses, unknown, ThrowOnError> => (options.client ?? client).post<CreateQuestionLibraryResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/question-libraries',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Load the active question library version
 */
export const getActiveQuestionLibrary = <ThrowOnError extends boolean = false>(options?: Options<GetActiveQuestionLibraryData, ThrowOnError>): RequestResult<GetActiveQuestionLibraryResponses, GetActiveQuestionLibraryErrors, ThrowOnError> => (options?.client ?? client).get<GetActiveQuestionLibraryResponses, GetActiveQuestionLibraryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/question-library/active',
    ...options
});

/**
 * Get playbook ask counts for the current user
 */
export const getQuestionLibraryCounts = <ThrowOnError extends boolean = false>(options: Options<GetQuestionLibraryCountsData, ThrowOnError>): RequestResult<GetQuestionLibraryCountsResponses, GetQuestionLibraryCountsErrors, ThrowOnError> => (options.client ?? client).get<GetQuestionLibraryCountsResponses, GetQuestionLibraryCountsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/question-library/{question_library_id}/counts',
    ...options
});

/**
 * Soft-delete a question library version (admin)
 */
export const deleteQuestionLibrary = <ThrowOnError extends boolean = false>(options: Options<DeleteQuestionLibraryData, ThrowOnError>): RequestResult<DeleteQuestionLibraryResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DeleteQuestionLibraryResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/question-libraries/{question_library_id}',
    ...options
});

/**
 * Load a question library version (admin)
 */
export const getQuestionLibrary = <ThrowOnError extends boolean = false>(options: Options<GetQuestionLibraryData, ThrowOnError>): RequestResult<GetQuestionLibraryResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetQuestionLibraryResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/question-libraries/{question_library_id}',
    ...options
});

/**
 * Update a question library version name (admin)
 */
export const updateQuestionLibraryTile = <ThrowOnError extends boolean = false>(options: Options<UpdateQuestionLibraryTileData, ThrowOnError>): RequestResult<UpdateQuestionLibraryTileResponses, unknown, ThrowOnError> => (options.client ?? client).patch<UpdateQuestionLibraryTileResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/question-libraries/{question_library_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Save a question library version (admin, requires edit lock)
 */
export const saveQuestionLibrary = <ThrowOnError extends boolean = false>(options: Options<SaveQuestionLibraryData, ThrowOnError>): RequestResult<SaveQuestionLibraryResponses, unknown, ThrowOnError> => (options.client ?? client).put<SaveQuestionLibraryResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/question-libraries/{question_library_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set a question library version as active (admin)
 */
export const activateQuestionLibrary = <ThrowOnError extends boolean = false>(options: Options<ActivateQuestionLibraryData, ThrowOnError>): RequestResult<ActivateQuestionLibraryResponses, unknown, ThrowOnError> => (options.client ?? client).post<ActivateQuestionLibraryResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/question-libraries/{question_library_id}/activate',
    ...options
});

/**
 * Restore a soft-deleted question library version (admin)
 */
export const restoreQuestionLibrary = <ThrowOnError extends boolean = false>(options: Options<RestoreQuestionLibraryData, ThrowOnError>): RequestResult<RestoreQuestionLibraryResponses, unknown, ThrowOnError> => (options.client ?? client).post<RestoreQuestionLibraryResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/question-libraries/{question_library_id}/restore',
    ...options
});

/**
 * Permanently delete a soft-deleted question library version (admin)
 */
export const forceDeleteQuestionLibrary = <ThrowOnError extends boolean = false>(options: Options<ForceDeleteQuestionLibraryData, ThrowOnError>): RequestResult<ForceDeleteQuestionLibraryResponses, ForceDeleteQuestionLibraryErrors, ThrowOnError> => (options.client ?? client).delete<ForceDeleteQuestionLibraryResponses, ForceDeleteQuestionLibraryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/question-libraries/{question_library_id}/force',
    ...options
});

/**
 * Release the question library edit lock (admin)
 */
export const releaseQuestionLibraryLock = <ThrowOnError extends boolean = false>(options: Options<ReleaseQuestionLibraryLockData, ThrowOnError>): RequestResult<ReleaseQuestionLibraryLockResponses, unknown, ThrowOnError> => (options.client ?? client).delete<ReleaseQuestionLibraryLockResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/question-libraries/{question_library_id}/lock',
    ...options
});

/**
 * Acquire or refresh the question library edit lock (admin)
 */
export const acquireQuestionLibraryLock = <ThrowOnError extends boolean = false>(options: Options<AcquireQuestionLibraryLockData, ThrowOnError>): RequestResult<AcquireQuestionLibraryLockResponses, unknown, ThrowOnError> => (options.client ?? client).post<AcquireQuestionLibraryLockResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin/question-libraries/{question_library_id}/lock',
    ...options
});

/**
 * List all users (admin only)
 */
export const listUsers = <ThrowOnError extends boolean = false>(options?: Options<ListUsersData, ThrowOnError>): RequestResult<ListUsersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListUsersResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users',
    ...options
});

/**
 * Create a new user (admin only)
 */
export const createUser = <ThrowOnError extends boolean = false>(options: Options<CreateUserData, ThrowOnError>): RequestResult<CreateUserResponses, CreateUserErrors, ThrowOnError> => (options.client ?? client).post<CreateUserResponses, CreateUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a user by public ID (admin only)
 */
export const deleteUser = <ThrowOnError extends boolean = false>(options: Options<DeleteUserData, ThrowOnError>): RequestResult<DeleteUserResponses, DeleteUserErrors, ThrowOnError> => (options.client ?? client).delete<DeleteUserResponses, DeleteUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/{user_id}',
    ...options
});

/**
 * Get a single user by public ID (admin only)
 */
export const getUser = <ThrowOnError extends boolean = false>(options: Options<GetUserData, ThrowOnError>): RequestResult<GetUserResponses, GetUserErrors, ThrowOnError> => (options.client ?? client).get<GetUserResponses, GetUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/{user_id}',
    ...options
});

/**
 * Update a user by public ID (admin only)
 */
export const updateUser = <ThrowOnError extends boolean = false>(options: Options<UpdateUserData, ThrowOnError>): RequestResult<UpdateUserResponses, UpdateUserErrors, ThrowOnError> => (options.client ?? client).patch<UpdateUserResponses, UpdateUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/{user_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get managed feature flags for a user (admin only)
 */
export const getUserFeatureFlags = <ThrowOnError extends boolean = false>(options: Options<GetUserFeatureFlagsData, ThrowOnError>): RequestResult<GetUserFeatureFlagsResponses, GetUserFeatureFlagsErrors, ThrowOnError> => (options.client ?? client).get<GetUserFeatureFlagsResponses, GetUserFeatureFlagsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/{user_id}/feature-flags',
    ...options
});

/**
 * Update managed feature flags for a user (admin only)
 */
export const updateUserFeatureFlags = <ThrowOnError extends boolean = false>(options: Options<UpdateUserFeatureFlagsData, ThrowOnError>): RequestResult<UpdateUserFeatureFlagsResponses, UpdateUserFeatureFlagsErrors, ThrowOnError> => (options.client ?? client).patch<UpdateUserFeatureFlagsResponses, UpdateUserFeatureFlagsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/{user_id}/feature-flags',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all available authentication providers (admin only)
 */
export const getAuthProviders = <ThrowOnError extends boolean = false>(options?: Options<GetAuthProvidersData, ThrowOnError>): RequestResult<GetAuthProvidersResponses, GetAuthProvidersErrors, ThrowOnError> => (options?.client ?? client).get<GetAuthProvidersResponses, GetAuthProvidersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/auth-providers',
    ...options
});

/**
 * Start impersonating the given user in GVTLabs or AskGVT (admin only)
 */
export const impersonateUser = <ThrowOnError extends boolean = false>(options: Options<ImpersonateUserData, ThrowOnError>): RequestResult<ImpersonateUserResponses, ImpersonateUserErrors, ThrowOnError> => (options.client ?? client).post<ImpersonateUserResponses, ImpersonateUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/{user_id}/impersonate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List analysis runs or configurations
 */
export const listProjectAnalysis = <ThrowOnError extends boolean = false>(options: Options<ListProjectAnalysisData, ThrowOnError>): RequestResult<ListProjectAnalysisResponses, ListProjectAnalysisErrors, ThrowOnError> => (options.client ?? client).get<ListProjectAnalysisResponses, ListProjectAnalysisErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/projects/{project_id}/analysis',
    ...options
});

/**
 * Get user statistics
 *
 * Returns counts of projects, pools, questions, and videos for the authenticated user
 */
export const getAppStats = <ThrowOnError extends boolean = false>(options?: Options<GetAppStatsData, ThrowOnError>): RequestResult<GetAppStatsResponses, GetAppStatsErrors, ThrowOnError> => (options?.client ?? client).get<GetAppStatsResponses, GetAppStatsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/app/stats',
    ...options
});

/**
 * Get admin dashboard statistics
 *
 * Returns aggregate counts of public pools, data pools, videos, and the most recent update timestamp
 */
export const getAdminDashboardStats = <ThrowOnError extends boolean = false>(options?: Options<GetAdminDashboardStatsData, ThrowOnError>): RequestResult<GetAdminDashboardStatsResponses, GetAdminDashboardStatsErrors, ThrowOnError> => (options?.client ?? client).get<GetAdminDashboardStatsResponses, GetAdminDashboardStatsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/admin-stats',
    ...options
});

/**
 * Check whether an artifact exists
 *
 * Returns 200 when the caller's account has a saved asset for this artifact id, otherwise 404 (same scoping as other by-id artifact routes).
 */
export const headArtifact = <ThrowOnError extends boolean = false>(options: Options<HeadArtifactData, ThrowOnError>): RequestResult<HeadArtifactResponses, HeadArtifactErrors, ThrowOnError> => (options.client ?? client).head<HeadArtifactResponses, HeadArtifactErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/artifacts/{artifact_id}',
    ...options
});

/**
 * List artifact document kinds
 *
 * Catalog of asset-registry document kinds with display metadata (icon, colour).
 */
export const listArtifactKinds = <ThrowOnError extends boolean = false>(options?: Options<ListArtifactKindsData, ThrowOnError>): RequestResult<ListArtifactKindsResponses, ListArtifactKindsErrors, ThrowOnError> => (options?.client ?? client).get<ListArtifactKindsResponses, ListArtifactKindsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/artifacts/kinds',
    ...options
});

/**
 * Delete multiple artifacts
 */
export const deleteArtifacts = <ThrowOnError extends boolean = false>(options: Options<DeleteArtifactsData, ThrowOnError>): RequestResult<DeleteArtifactsResponses, DeleteArtifactsErrors, ThrowOnError> => (options.client ?? client).delete<DeleteArtifactsResponses, DeleteArtifactsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/artifacts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List artifacts
 */
export const listArtifacts = <ThrowOnError extends boolean = false>(options?: Options<ListArtifactsData, ThrowOnError>): RequestResult<ListArtifactsResponses, ListArtifactsErrors, ThrowOnError> => (options?.client ?? client).get<ListArtifactsResponses, ListArtifactsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/artifacts',
    ...options
});

/**
 * Create a new artifact document
 */
export const createArtifact = <ThrowOnError extends boolean = false>(options: Options<CreateArtifactData, ThrowOnError>): RequestResult<CreateArtifactResponses, CreateArtifactErrors, ThrowOnError> => (options.client ?? client).post<CreateArtifactResponses, CreateArtifactErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/artifacts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all artifacts for a question with full file metadata
 */
export const listArtifactsByQuestion = <ThrowOnError extends boolean = false>(options: Options<ListArtifactsByQuestionData, ThrowOnError>): RequestResult<ListArtifactsByQuestionResponses, ListArtifactsByQuestionErrors, ThrowOnError> => (options.client ?? client).get<ListArtifactsByQuestionResponses, ListArtifactsByQuestionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/artifacts-by-question/{question_id}',
    ...options
});

/**
 * Toggle document is_favourite on or off
 */
export const toggleArtifactFavourite = <ThrowOnError extends boolean = false>(options: Options<ToggleArtifactFavouriteData, ThrowOnError>): RequestResult<ToggleArtifactFavouriteResponses, ToggleArtifactFavouriteErrors, ThrowOnError> => (options.client ?? client).patch<ToggleArtifactFavouriteResponses, ToggleArtifactFavouriteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/artifacts/{document_id}/favourite',
    ...options
});

/**
 * Get an artifact
 */
export const getArtifact = <ThrowOnError extends boolean = false>(options: Options<GetArtifactData, ThrowOnError>): RequestResult<GetArtifactResponses, GetArtifactErrors, ThrowOnError> => (options.client ?? client).get<GetArtifactResponses, GetArtifactErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/artifacts/{document_id}',
    ...options
});

/**
 * List a document's files
 */
export const listArtifactFiles = <ThrowOnError extends boolean = false>(options: Options<ListArtifactFilesData, ThrowOnError>): RequestResult<ListArtifactFilesResponses, ListArtifactFilesErrors, ThrowOnError> => (options.client ?? client).get<ListArtifactFilesResponses, ListArtifactFilesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/artifacts/{document_id}/files',
    ...options
});

/**
 * Download a document's file
 */
export const downloadArtifactFile = <ThrowOnError extends boolean = false>(options: Options<DownloadArtifactFileData, ThrowOnError>): RequestResult<DownloadArtifactFileResponses, DownloadArtifactFileErrors, ThrowOnError> => (options.client ?? client).get<DownloadArtifactFileResponses, DownloadArtifactFileErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/artifacts/{document_id}/download/{file_id}',
    ...options
});

/**
 * Move the AskGVT plan
 *
 * An upgrade takes effect immediately. A downgrade is scheduled for the end of the current period. Moving to the free plan cancels.
 */
export const changeAskGvtPlan = <ThrowOnError extends boolean = false>(options: Options<ChangeAskGvtPlanData, ThrowOnError>): RequestResult<ChangeAskGvtPlanResponses, ChangeAskGvtPlanErrors, ThrowOnError> => (options.client ?? client).patch<ChangeAskGvtPlanResponses, ChangeAskGvtPlanErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/askgvt/billing/subscription',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Subscribe the account to an AskGVT plan with a saved card
 */
export const subscribeToAskGvtPlan = <ThrowOnError extends boolean = false>(options: Options<SubscribeToAskGvtPlanData, ThrowOnError>): RequestResult<SubscribeToAskGvtPlanResponses, SubscribeToAskGvtPlanErrors, ThrowOnError> => (options.client ?? client).post<SubscribeToAskGvtPlanResponses, SubscribeToAskGvtPlanErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/askgvt/billing/subscription',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create the current influencer's AskPage pool
 *
 * Idempotent: repeat calls return the existing AskPage pool rather than creating a second one.
 */
export const createAskPagePool = <ThrowOnError extends boolean = false>(options?: Options<CreateAskPagePoolData, ThrowOnError>): RequestResult<CreateAskPagePoolResponses, CreateAskPagePoolErrors, ThrowOnError> => (options?.client ?? client).post<CreateAskPagePoolResponses, CreateAskPagePoolErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer/ask-page',
    ...options
});

/**
 * List the post public_ids currently curated into the influencer's AskPage
 */
export const listAskPagePosts = <ThrowOnError extends boolean = false>(options?: Options<ListAskPagePostsData, ThrowOnError>): RequestResult<ListAskPagePostsResponses, ListAskPagePostsErrors, ThrowOnError> => (options?.client ?? client).get<ListAskPagePostsResponses, ListAskPagePostsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer/ask-page/posts',
    ...options
});

/**
 * Remove one of the influencer's own posts from their AskPage
 *
 * Idempotent. Only affects the AskPage pool.
 */
export const removeAskPagePost = <ThrowOnError extends boolean = false>(options: Options<RemoveAskPagePostData, ThrowOnError>): RequestResult<RemoveAskPagePostResponses, RemoveAskPagePostErrors, ThrowOnError> => (options.client ?? client).delete<RemoveAskPagePostResponses, RemoveAskPagePostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer/ask-page/posts/{post_id}',
    ...options
});

/**
 * Include one of the influencer's own posts in their AskPage
 *
 * Idempotent. Only affects the AskPage pool - never the private Studio pool or any consented public pool.
 */
export const addAskPagePost = <ThrowOnError extends boolean = false>(options: Options<AddAskPagePostData, ThrowOnError>): RequestResult<AddAskPagePostResponses, AddAskPagePostErrors, ThrowOnError> => (options.client ?? client).post<AddAskPagePostResponses, AddAskPagePostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer/ask-page/posts/{post_id}',
    ...options
});

/**
 * Get the current influencer's public AskPage appearance/content settings
 */
export const getAskPageSettings = <ThrowOnError extends boolean = false>(options?: Options<GetAskPageSettingsData, ThrowOnError>): RequestResult<GetAskPageSettingsResponses, GetAskPageSettingsErrors, ThrowOnError> => (options?.client ?? client).get<GetAskPageSettingsResponses, GetAskPageSettingsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer/ask-page/settings',
    ...options
});

/**
 * Update the current influencer's public AskPage appearance/content settings
 *
 * Partial update - only the fields present in the request body are changed. `description` writes to the same `biography` field shown on the old profile page.
 */
export const updateAskPageSettings = <ThrowOnError extends boolean = false>(options?: Options<UpdateAskPageSettingsData, ThrowOnError>): RequestResult<UpdateAskPageSettingsResponses, UpdateAskPageSettingsErrors, ThrowOnError> => (options?.client ?? client).patch<UpdateAskPageSettingsResponses, UpdateAskPageSettingsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer/ask-page/settings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Upload the current influencer's AskPage banner and where to crop it
 *
 * Saves immediately. The server cuts a 3:1 banner (banner_url, used by the apps) and a 5:1 banner (banner_web_url) from the image, and keeps the original so the crops can be edited later.
 */
export const uploadAskPageBanner = <ThrowOnError extends boolean = false>(options: Options<UploadAskPageBannerData, ThrowOnError>): RequestResult<UploadAskPageBannerResponses, UploadAskPageBannerErrors, ThrowOnError> => (options.client ?? client).post<UploadAskPageBannerResponses, UploadAskPageBannerErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer/ask-page/banner',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Download the current AskPage banner for in-browser editing
 *
 * Same-origin proxy for the crop panel; public banner_url hosts often block cross-origin fetch from the app. Returns the original upload that banner_crops refer to, or the 3:1 banner when there is none.
 */
export const downloadAskPageBannerSource = <ThrowOnError extends boolean = false>(options?: Options<DownloadAskPageBannerSourceData, ThrowOnError>): RequestResult<DownloadAskPageBannerSourceResponses, DownloadAskPageBannerSourceErrors, ThrowOnError> => (options?.client ?? client).get<DownloadAskPageBannerSourceResponses, DownloadAskPageBannerSourceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer/ask-page/banner/source',
    ...options
});

/**
 * Get a presigned URL to upload the current influencer's AskPage banner image
 *
 * The client PUTs the file directly to the returned url, then saves bucket/key via PATCH .../settings. Kept for app versions that upload a ready-made 3:1 banner; new clients use POST /api/influencer/ask-page/banner.
 *
 * @deprecated
 */
export const presignAskPageBannerUpload = <ThrowOnError extends boolean = false>(options: Options<PresignAskPageBannerUploadData, ThrowOnError>): RequestResult<PresignAskPageBannerUploadResponses, PresignAskPageBannerUploadErrors, ThrowOnError> => (options.client ?? client).post<PresignAskPageBannerUploadResponses, PresignAskPageBannerUploadErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer/ask-page/banner/presign-upload',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Claim an anonymous AskPage thread into the caller's Ask questions
 *
 * Copies the thread the given question belongs to into a new thread owned by the authenticated user, and returns the copy of that question. Idempotent: claiming the same thread again returns the caller's existing copy rather than creating a duplicate.
 */
export const claimAskPageAnswer = <ThrowOnError extends boolean = false>(options: Options<ClaimAskPageAnswerData, ThrowOnError>): RequestResult<ClaimAskPageAnswerResponses, ClaimAskPageAnswerErrors, ThrowOnError> => (options.client ?? client).post<ClaimAskPageAnswerResponses, ClaimAskPageAnswerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/me/ask-page-claims',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Purchase a time-limited AskPage pass for a creator
 *
 * Disabled unless services.ask_page.enable_checkout is on. Rejected if the caller already holds any active entitlement (pass or subscription) for this creator.
 */
export const purchaseAskPagePass = <ThrowOnError extends boolean = false>(options: Options<PurchaseAskPagePassData, ThrowOnError>): RequestResult<PurchaseAskPagePassResponses, PurchaseAskPagePassErrors, ThrowOnError> => (options.client ?? client).post<PurchaseAskPagePassResponses, PurchaseAskPagePassErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/me/ask-page-entitlements/purchase-pass',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start a monthly AskPage subscription for a creator
 *
 * Disabled unless services.ask_page.enable_checkout is on. Rejected if the caller already holds any active entitlement (pass or subscription) for this creator.
 */
export const subscribeToAskPage = <ThrowOnError extends boolean = false>(options: Options<SubscribeToAskPageData, ThrowOnError>): RequestResult<SubscribeToAskPageResponses, SubscribeToAskPageErrors, ThrowOnError> => (options.client ?? client).post<SubscribeToAskPageResponses, SubscribeToAskPageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/me/ask-page-entitlements/subscribe',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Confirm an AskPage pass purchase or subscription that required a 3-D Secure challenge
 *
 * Disabled unless services.ask_page.enable_checkout is on. Re-checks the payment directly with Stripe rather than trusting the browser; idempotent once the entitlement has already been granted.
 */
export const confirmAskPagePurchase = <ThrowOnError extends boolean = false>(options: Options<ConfirmAskPagePurchaseData, ThrowOnError>): RequestResult<ConfirmAskPagePurchaseResponses, ConfirmAskPagePurchaseErrors, ThrowOnError> => (options.client ?? client).post<ConfirmAskPagePurchaseResponses, ConfirmAskPagePurchaseErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/me/ask-page-entitlements/confirm',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * One report of the current creator's Audience Insights
 */
export const getAskPageInsights = <ThrowOnError extends boolean = false>(options?: Options<GetAskPageInsightsData, ThrowOnError>): RequestResult<GetAskPageInsightsResponses, GetAskPageInsightsErrors, ThrowOnError> => (options?.client ?? client).get<GetAskPageInsightsResponses, GetAskPageInsightsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer/ask-page/insights',
    ...options
});

/**
 * Save a topic from the current creator's Insights as a video brief
 */
export const saveAskPageInsightsBrief = <ThrowOnError extends boolean = false>(options: Options<SaveAskPageInsightsBriefData, ThrowOnError>): RequestResult<SaveAskPageInsightsBriefResponses, SaveAskPageInsightsBriefErrors, ThrowOnError> => (options.client ?? client).post<SaveAskPageInsightsBriefResponses, SaveAskPageInsightsBriefErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer/ask-page/insights/briefs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove a saved video brief
 */
export const removeAskPageInsightsBrief = <ThrowOnError extends boolean = false>(options: Options<RemoveAskPageInsightsBriefData, ThrowOnError>): RequestResult<RemoveAskPageInsightsBriefResponses, RemoveAskPageInsightsBriefErrors, ThrowOnError> => (options.client ?? client).delete<RemoveAskPageInsightsBriefResponses, RemoveAskPageInsightsBriefErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer/ask-page/insights/briefs/{brief_id}',
    ...options
});

/**
 * Mark a saved brief covered by one of the creator's videos
 */
export const coverAskPageInsightsBrief = <ThrowOnError extends boolean = false>(options: Options<CoverAskPageInsightsBriefData, ThrowOnError>): RequestResult<CoverAskPageInsightsBriefResponses, CoverAskPageInsightsBriefErrors, ThrowOnError> => (options.client ?? client).post<CoverAskPageInsightsBriefResponses, CoverAskPageInsightsBriefErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer/ask-page/insights/briefs/{brief_id}/cover',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Say the video marked as covering a brief doesn't; it is never matched to it again
 */
export const uncoverAskPageInsightsBrief = <ThrowOnError extends boolean = false>(options: Options<UncoverAskPageInsightsBriefData, ThrowOnError>): RequestResult<UncoverAskPageInsightsBriefResponses, UncoverAskPageInsightsBriefErrors, ThrowOnError> => (options.client ?? client).post<UncoverAskPageInsightsBriefResponses, UncoverAskPageInsightsBriefErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer/ask-page/insights/briefs/{brief_id}/uncover',
    ...options
});

/**
 * The creator's latest videos, to pick the one that covers a brief
 */
export const getAskPageInsightsVideos = <ThrowOnError extends boolean = false>(options?: Options<GetAskPageInsightsVideosData, ThrowOnError>): RequestResult<GetAskPageInsightsVideosResponses, GetAskPageInsightsVideosErrors, ThrowOnError> => (options?.client ?? client).get<GetAskPageInsightsVideosResponses, GetAskPageInsightsVideosErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer/ask-page/insights/videos',
    ...options
});

/**
 * Write (once) and return the week's note
 */
export const generateAskPageInsightsSummary = <ThrowOnError extends boolean = false>(options: Options<GenerateAskPageInsightsSummaryData, ThrowOnError>): RequestResult<GenerateAskPageInsightsSummaryResponses, GenerateAskPageInsightsSummaryErrors, ThrowOnError> => (options.client ?? client).post<GenerateAskPageInsightsSummaryResponses, GenerateAskPageInsightsSummaryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer/ask-page/insights/summary',
    ...options
});

/**
 * List the current user's own questions asked of a single creator's AskPage or of all their subscribed creators
 */
export const getMyAskPageQuestions = <ThrowOnError extends boolean = false>(options?: Options<GetMyAskPageQuestionsData, ThrowOnError>): RequestResult<GetMyAskPageQuestionsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetMyAskPageQuestionsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/me/ask-page-questions',
    ...options
});

/**
 * List the caller's own AskPage shares
 *
 * Only permanent shares created while authenticated — anonymous, visitor-scoped shares have no owning account to list them under.
 */
export const listAskPageShares = <ThrowOnError extends boolean = false>(options?: Options<ListAskPageSharesData, ThrowOnError>): RequestResult<ListAskPageSharesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListAskPageSharesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/me/ask-page-shares',
    ...options
});

/**
 * Create a static, shareable snapshot of an AskPage thread
 *
 * Idempotent: sharing the same question again as the same caller returns the existing share rather than creating a duplicate.
 */
export const createAskPageShare = <ThrowOnError extends boolean = false>(options: Options<CreateAskPageShareData, ThrowOnError>): RequestResult<CreateAskPageShareResponses, CreateAskPageShareErrors, ThrowOnError> => (options.client ?? client).post<CreateAskPageShareResponses, CreateAskPageShareErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/me/ask-page-shares',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create a temporary, shareable snapshot of an AskPage thread asked as a guest
 *
 * For a guest, recognised by their visitor cookie, sharing a thread they asked that has not been claimed into an account. The share expires 24 hours after it was created. Idempotent while the share is live.
 */
export const createAnonymousAskPageShare = <ThrowOnError extends boolean = false>(options: Options<CreateAnonymousAskPageShareData, ThrowOnError>): RequestResult<CreateAnonymousAskPageShareResponses, CreateAnonymousAskPageShareErrors, ThrowOnError> => (options.client ?? client).post<CreateAnonymousAskPageShareResponses, CreateAnonymousAskPageShareErrors, ThrowOnError>({
    url: '/api/public/ask-page-shares',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke one of the caller's own AskPage shares
 *
 * Idempotent: revoking an already-revoked share leaves its original revoked_at untouched and still returns success. Sets revoked_at rather than deleting, preserving history.
 */
export const revokeAskPageShare = <ThrowOnError extends boolean = false>(options: Options<RevokeAskPageShareData, ThrowOnError>): RequestResult<RevokeAskPageShareResponses, RevokeAskPageShareErrors, ThrowOnError> => (options.client ?? client).delete<RevokeAskPageShareResponses, RevokeAskPageShareErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/me/ask-page-shares/{share_public_id}',
    ...options
});

/**
 * Change whether search engines may index one of the caller's own AskPage shares
 */
export const updateAskPageShare = <ThrowOnError extends boolean = false>(options: Options<UpdateAskPageShareData, ThrowOnError>): RequestResult<UpdateAskPageShareResponses, UpdateAskPageShareErrors, ThrowOnError> => (options.client ?? client).patch<UpdateAskPageShareResponses, UpdateAskPageShareErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/me/ask-page-shares/{share_public_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List the current user's AskPage subscriptions
 *
 * Filter with status=active (default) or status=expired, and q to match creator handle or display name. Entitlement type is returned for a status badge, not remaining time - callers should not display a countdown from it.
 */
export const getMyAskPageSubscriptions = <ThrowOnError extends boolean = false>(options?: Options<GetMyAskPageSubscriptionsData, ThrowOnError>): RequestResult<GetMyAskPageSubscriptionsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetMyAskPageSubscriptionsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/me/ask-page-subscriptions',
    ...options
});

/**
 * Subscribe to an unpaid AskPage
 *
 * Creates an open-ended free entitlement for the signed-in account. Paid pages must use the checkout subscribe path. Idempotent if the caller is already entitled.
 */
export const subscribeToFreeAskPage = <ThrowOnError extends boolean = false>(options: Options<SubscribeToFreeAskPageData, ThrowOnError>): RequestResult<SubscribeToFreeAskPageResponses, SubscribeToFreeAskPageErrors, ThrowOnError> => (options.client ?? client).post<SubscribeToFreeAskPageResponses, SubscribeToFreeAskPageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/me/ask-page-subscriptions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Cancel one of the current user's monthly AskPage subscriptions
 *
 * Not immediate revocation where a billing period is on record - access continues through current_period_end. Takes effect immediately for a row with no current_period_end (an older admin/QA grant).
 */
export const cancelMyAskPageSubscription = <ThrowOnError extends boolean = false>(options: Options<CancelMyAskPageSubscriptionData, ThrowOnError>): RequestResult<CancelMyAskPageSubscriptionResponses, CancelMyAskPageSubscriptionErrors, ThrowOnError> => (options.client ?? client).post<CancelMyAskPageSubscriptionResponses, CancelMyAskPageSubscriptionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/me/ask-page-subscriptions/{id}/cancel',
    ...options
});

/**
 * List audio files in a project pool
 */
export const listProjectAudio = <ThrowOnError extends boolean = false>(options: Options<ListProjectAudioData, ThrowOnError>): RequestResult<ListProjectAudioResponses, ListProjectAudioErrors, ThrowOnError> => (options.client ?? client).get<ListProjectAudioResponses, ListProjectAudioErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/projects/{project_id}/audio',
    ...options
});

/**
 * Sign out
 *
 * Ends the current browser session and, when called with an Authorization: Bearer token, revokes that Sanctum access token. No authentication required; safe to call when already signed out.
 */
export const signOut = <ThrowOnError extends boolean = false>(options?: Options<SignOutData, ThrowOnError>): RequestResult<SignOutResponses, SignOutErrors, ThrowOnError> => (options?.client ?? client).post<SignOutResponses, SignOutErrors, ThrowOnError>({ url: '/api/sign-out', ...options });

/**
 * List public boards
 */
export const listPublicBoards = <ThrowOnError extends boolean = false>(options?: Options<ListPublicBoardsData, ThrowOnError>): RequestResult<ListPublicBoardsResponses, ListPublicBoardsErrors, ThrowOnError> => (options?.client ?? client).get<ListPublicBoardsResponses, ListPublicBoardsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/public-boards',
    ...options
});

/**
 * List followed boards
 */
export const listFollowedBoards = <ThrowOnError extends boolean = false>(options?: Options<ListFollowedBoardsData, ThrowOnError>): RequestResult<ListFollowedBoardsResponses, ListFollowedBoardsErrors, ThrowOnError> => (options?.client ?? client).get<ListFollowedBoardsResponses, ListFollowedBoardsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/boards/followed',
    ...options
});

/**
 * List owner's boards
 */
export const listBoards = <ThrowOnError extends boolean = false>(options?: Options<ListBoardsData, ThrowOnError>): RequestResult<ListBoardsResponses, ListBoardsErrors, ThrowOnError> => (options?.client ?? client).get<ListBoardsResponses, ListBoardsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/boards',
    ...options
});

/**
 * Create a new board
 */
export const createBoard = <ThrowOnError extends boolean = false>(options: Options<CreateBoardData, ThrowOnError>): RequestResult<CreateBoardResponses, CreateBoardErrors, ThrowOnError> => (options.client ?? client).post<CreateBoardResponses, CreateBoardErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/boards',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get boards by video IDs
 */
export const getBoardsByVideoIds = <ThrowOnError extends boolean = false>(options: Options<GetBoardsByVideoIdsData, ThrowOnError>): RequestResult<GetBoardsByVideoIdsResponses, GetBoardsByVideoIdsErrors, ThrowOnError> => (options.client ?? client).get<GetBoardsByVideoIdsResponses, GetBoardsByVideoIdsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/boards/by_video_ids',
    ...options
});

/**
 * Delete a board
 */
export const deleteBoard = <ThrowOnError extends boolean = false>(options: Options<DeleteBoardData, ThrowOnError>): RequestResult<DeleteBoardResponses, DeleteBoardErrors, ThrowOnError> => (options.client ?? client).delete<DeleteBoardResponses, DeleteBoardErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/boards/{board_id}',
    ...options
});

/**
 * Get board details
 */
export const getBoard = <ThrowOnError extends boolean = false>(options: Options<GetBoardData, ThrowOnError>): RequestResult<GetBoardResponses, GetBoardErrors, ThrowOnError> => (options.client ?? client).get<GetBoardResponses, GetBoardErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/boards/{board_id}',
    ...options
});

/**
 * Update board metadata
 */
export const updateBoard = <ThrowOnError extends boolean = false>(options: Options<UpdateBoardData, ThrowOnError>): RequestResult<UpdateBoardResponses, UpdateBoardErrors, ThrowOnError> => (options.client ?? client).patch<UpdateBoardResponses, UpdateBoardErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/boards/{board_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Unfollow a board
 */
export const unfollowBoard = <ThrowOnError extends boolean = false>(options: Options<UnfollowBoardData, ThrowOnError>): RequestResult<UnfollowBoardResponses, UnfollowBoardErrors, ThrowOnError> => (options.client ?? client).delete<UnfollowBoardResponses, UnfollowBoardErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/boards/{board_id}/follow',
    ...options
});

/**
 * Follow a public board
 */
export const followBoard = <ThrowOnError extends boolean = false>(options: Options<FollowBoardData, ThrowOnError>): RequestResult<FollowBoardResponses, FollowBoardErrors, ThrowOnError> => (options.client ?? client).post<FollowBoardResponses, FollowBoardErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/boards/{board_id}/follow',
    ...options
});

/**
 * Get a clip by id
 */
export const getBoardClip = <ThrowOnError extends boolean = false>(options: Options<GetBoardClipData, ThrowOnError>): RequestResult<GetBoardClipResponses, GetBoardClipErrors, ThrowOnError> => (options.client ?? client).get<GetBoardClipResponses, GetBoardClipErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/boards/{board_id}/clips/{clip_id}',
    ...options
});

/**
 * Update board clip metadata
 */
export const updateBoardClip = <ThrowOnError extends boolean = false>(options: Options<UpdateBoardClipData, ThrowOnError>): RequestResult<UpdateBoardClipResponses, UpdateBoardClipErrors, ThrowOnError> => (options.client ?? client).patch<UpdateBoardClipResponses, UpdateBoardClipErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/boards/{board_id}/clips/{clip_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Restore a board
 */
export const restoreBoard = <ThrowOnError extends boolean = false>(options: Options<RestoreBoardData, ThrowOnError>): RequestResult<RestoreBoardResponses, RestoreBoardErrors, ThrowOnError> => (options.client ?? client).post<RestoreBoardResponses, RestoreBoardErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/boards/{board_id}/restore',
    ...options
});

/**
 * Add a clip to a board
 *
 * Provide board_id in the JSON body, or call POST /api/boards/{board_id}/clips with the same body (legacy path). If not supplied then the last used board is used. If no board then a new board is created.
 */
export const addClipToBoard = <ThrowOnError extends boolean = false>(options: Options<AddClipToBoardData, ThrowOnError>): RequestResult<AddClipToBoardResponses, AddClipToBoardErrors, ThrowOnError> => (options.client ?? client).post<AddClipToBoardResponses, AddClipToBoardErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/boards/clips',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete multiple clips
 */
export const deleteClips = <ThrowOnError extends boolean = false>(options: Options<DeleteClipsData, ThrowOnError>): RequestResult<DeleteClipsResponses, DeleteClipsErrors, ThrowOnError> => (options.client ?? client).delete<DeleteClipsResponses, DeleteClipsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/boards/{board_id}/clips',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List items in a board
 */
export const listBoardClips = <ThrowOnError extends boolean = false>(options: Options<ListBoardClipsData, ThrowOnError>): RequestResult<ListBoardClipsResponses, ListBoardClipsErrors, ThrowOnError> => (options.client ?? client).get<ListBoardClipsResponses, ListBoardClipsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/boards/{board_id}/clips',
    ...options
});

/**
 * Undo delete multiple clips
 */
export const restoreClips = <ThrowOnError extends boolean = false>(options: Options<RestoreClipsData, ThrowOnError>): RequestResult<RestoreClipsResponses, RestoreClipsErrors, ThrowOnError> => (options.client ?? client).post<RestoreClipsResponses, RestoreClipsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/boards/{board_id}/clips/restore',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Download assets for multiple clips as a ZIP file
 */
export const downloadAssets = <ThrowOnError extends boolean = false>(options: Options<DownloadAssetsData, ThrowOnError>): RequestResult<DownloadAssetsResponses, DownloadAssetsErrors, ThrowOnError> => (options.client ?? client).post<DownloadAssetsResponses, DownloadAssetsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/boards/{board_id}/download-assets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Download assets for multiple clips as a ZIP file
 */
export const downloadAllAssets = <ThrowOnError extends boolean = false>(options: Options<DownloadAllAssetsData, ThrowOnError>): RequestResult<DownloadAllAssetsResponses, DownloadAllAssetsErrors, ThrowOnError> => (options.client ?? client).post<DownloadAllAssetsResponses, DownloadAllAssetsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/boards/{board_id}/download-all-assets',
    ...options
});

/**
 * List suggested consumer discovery categories
 *
 * Returns home-grid categories from discovery_categories (active taxonomy), with creator counts and up to three random creators from discovery_creator_coverage.
 */
export const listDiscoveryCategories = <ThrowOnError extends boolean = false>(options?: Options<ListDiscoveryCategoriesData, ThrowOnError>): RequestResult<ListDiscoveryCategoriesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListDiscoveryCategoriesResponses, unknown, ThrowOnError>({ url: '/api/categories', ...options });

/**
 * List discovery category groups
 *
 * Returns the taxonomy for the all-categories modal, one section per top-level category, with that category's children as items.
 */
export const listCategoryGroups = <ThrowOnError extends boolean = false>(options?: Options<ListCategoryGroupsData, ThrowOnError>): RequestResult<ListCategoryGroupsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListCategoryGroupsResponses, unknown, ThrowOnError>({ url: '/api/category/groups', ...options });

/**
 * List creators for many discovery categories
 *
 * Accepts up to 200 category slugs and returns up to 10 influencers per slug from discovery_creator_coverage (parent expands to children).
 */
export const listDiscoveryCreatorsByCategory = <ThrowOnError extends boolean = false>(options: Options<ListDiscoveryCreatorsByCategoryData, ThrowOnError>): RequestResult<ListDiscoveryCreatorsByCategoryResponses, unknown, ThrowOnError> => (options.client ?? client).post<ListDiscoveryCreatorsByCategoryResponses, unknown, ThrowOnError>({
    url: '/api/categories/creators/by-category',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List creators in a discovery category
 *
 * Returns influencers from discovery_creator_coverage for the category slug (parent expands to children).
 */
export const listDiscoveryCategoryCreators = <ThrowOnError extends boolean = false>(options: Options<ListDiscoveryCategoryCreatorsData, ThrowOnError>): RequestResult<ListDiscoveryCategoryCreatorsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListDiscoveryCategoryCreatorsResponses, unknown, ThrowOnError>({ url: '/api/categories/{slug}/creators', ...options });

/**
 * List suggested influencers for discovery
 *
 * Returns up to 20 influencers. For a signed-in viewer the list mixes creators from followed categories with creators similar to followed boards and to creators they have asked, weighted by the discovery.suggested.* settings. Guests, and viewers with nothing to go on, get the global ranking by discovery coverage (fallback: verified follower totals). Never includes the viewer, creators they follow, creators they hold an active AskPage entitlement for, or creators they have already asked.
 */
export const listDiscoverySuggestedInfluencers = <ThrowOnError extends boolean = false>(options?: Options<ListDiscoverySuggestedInfluencersData, ThrowOnError>): RequestResult<ListDiscoverySuggestedInfluencersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListDiscoverySuggestedInfluencersResponses, unknown, ThrowOnError>({ url: '/api/discovery/suggested-influencers', ...options });

/**
 * List the creator's drafts, newest first.
 */
export const listStudioDrafts = <ThrowOnError extends boolean = false>(options?: Options<ListStudioDraftsData, ThrowOnError>): RequestResult<ListStudioDraftsResponses, ListStudioDraftsErrors, ThrowOnError> => (options?.client ?? client).get<ListStudioDraftsResponses, ListStudioDraftsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/studio/drafts',
    ...options
});

/**
 * Delete a draft with its video and the questions asked about it.
 */
export const deleteStudioDraft = <ThrowOnError extends boolean = false>(options: Options<DeleteStudioDraftData, ThrowOnError>): RequestResult<DeleteStudioDraftResponses, DeleteStudioDraftErrors, ThrowOnError> => (options.client ?? client).delete<DeleteStudioDraftResponses, DeleteStudioDraftErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/studio/drafts/{draft_id}',
    ...options
});

/**
 * Get one of the creator's drafts.
 */
export const getStudioDraft = <ThrowOnError extends boolean = false>(options: Options<GetStudioDraftData, ThrowOnError>): RequestResult<GetStudioDraftResponses, GetStudioDraftErrors, ThrowOnError> => (options.client ?? client).get<GetStudioDraftResponses, GetStudioDraftErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/studio/drafts/{draft_id}',
    ...options
});

/**
 * List the caller's questions about one draft, newest first.
 */
export const listStudioDraftQuestions = <ThrowOnError extends boolean = false>(options: Options<ListStudioDraftQuestionsData, ThrowOnError>): RequestResult<ListStudioDraftQuestionsResponses, ListStudioDraftQuestionsErrors, ThrowOnError> => (options.client ?? client).get<ListStudioDraftQuestionsResponses, ListStudioDraftQuestionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/studio/drafts/{draft_id}/questions',
    ...options
});

/**
 * Platforms and example URLs accepted by POST /api/studio/drafts/link.
 */
export const listStudioDraftLinkAllowedPlatforms = <ThrowOnError extends boolean = false>(options?: Options<ListStudioDraftLinkAllowedPlatformsData, ThrowOnError>): RequestResult<ListStudioDraftLinkAllowedPlatformsResponses, ListStudioDraftLinkAllowedPlatformsErrors, ThrowOnError> => (options?.client ?? client).get<ListStudioDraftLinkAllowedPlatformsResponses, ListStudioDraftLinkAllowedPlatformsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/studio/drafts/link/allowed_platforms',
    ...options
});

/**
 * Create a draft from one social video URL (YouTube, TikTok, Instagram, Facebook, or X).
 */
export const linkStudioDraft = <ThrowOnError extends boolean = false>(options: Options<LinkStudioDraftData, ThrowOnError>): RequestResult<LinkStudioDraftResponses, LinkStudioDraftErrors, ThrowOnError> => (options.client ?? client).post<LinkStudioDraftResponses, LinkStudioDraftErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/studio/drafts/link',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start processing a draft again after it never started or failed temporarily.
 */
export const processStudioDraft = <ThrowOnError extends boolean = false>(options: Options<ProcessStudioDraftData, ThrowOnError>): RequestResult<ProcessStudioDraftResponses, ProcessStudioDraftErrors, ThrowOnError> => (options.client ?? client).post<ProcessStudioDraftResponses, ProcessStudioDraftErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/studio/drafts/{draft_id}/process',
    ...options
});

/**
 * Move a ready draft into the creator's library as a direct upload.
 *
 * Only fully processed drafts (not held or blocked by content moderation) can be published. File uploads and Companion imports are always eligible when ready. Link drafts also require the creator to have connected and verified the social channel the video came from. Prior questions about the draft are re-homed to the library.
 */
export const publishStudioDraft = <ThrowOnError extends boolean = false>(options: Options<PublishStudioDraftData, ThrowOnError>): RequestResult<PublishStudioDraftResponses, PublishStudioDraftErrors, ThrowOnError> => (options.client ?? client).post<PublishStudioDraftResponses, PublishStudioDraftErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/studio/drafts/{draft_id}/publish',
    ...options
});

/**
 * Submit product feedback
 *
 * Queues authenticated user feedback for processing in Canny Autopilot.
 */
export const submitFeedback = <ThrowOnError extends boolean = false>(options: Options<SubmitFeedbackData, ThrowOnError>): RequestResult<SubmitFeedbackResponses, SubmitFeedbackErrors, ThrowOnError> => (options.client ?? client).post<SubmitFeedbackResponses, SubmitFeedbackErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/feedback',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get the auto process status
 *
 * Deprecated: use GET /api/influencer/connected_accounts/stats (auto_process) instead.
 *
 * @deprecated
 */
export const getAutoProcess = <ThrowOnError extends boolean = false>(options?: Options<GetAutoProcessData, ThrowOnError>): RequestResult<GetAutoProcessResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetAutoProcessResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer/auto_process',
    ...options
});

/**
 * Update the auto process status
 */
export const patchAutoProcess = <ThrowOnError extends boolean = false>(options: Options<PatchAutoProcessData, ThrowOnError>): RequestResult<PatchAutoProcessResponses, unknown, ThrowOnError> => (options.client ?? client).patch<PatchAutoProcessResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer/auto_process',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get stats for all connected accounts
 */
export const getConnectedAccountsStats = <ThrowOnError extends boolean = false>(options?: Options<GetConnectedAccountsStatsData, ThrowOnError>): RequestResult<GetConnectedAccountsStatsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetConnectedAccountsStatsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer/connected_accounts/stats',
    ...options
});

/**
 * Trigger post collection for a connected account
 */
export const collectPosts = <ThrowOnError extends boolean = false>(options: Options<CollectPostsData, ThrowOnError>): RequestResult<CollectPostsResponses, unknown, ThrowOnError> => (options.client ?? client).post<CollectPostsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer/connected_accounts/{account_id}/collect_posts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Trigger batched backfill of older posts for a connected account
 */
export const backfillPosts = <ThrowOnError extends boolean = false>(options: Options<BackfillPostsData, ThrowOnError>): RequestResult<BackfillPostsResponses, BackfillPostsErrors, ThrowOnError> => (options.client ?? client).post<BackfillPostsResponses, BackfillPostsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer/connected_accounts/{account_id}/backfill_posts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Extend collected history by one year for all verified connected accounts
 */
export const backfillPostsForAllAccounts = <ThrowOnError extends boolean = false>(options: Options<BackfillPostsForAllAccountsData, ThrowOnError>): RequestResult<BackfillPostsForAllAccountsResponses, BackfillPostsForAllAccountsErrors, ThrowOnError> => (options.client ?? client).post<BackfillPostsForAllAccountsResponses, BackfillPostsForAllAccountsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer/connected_accounts/backfill_posts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Trigger post collection for all connected accounts
 */
export const collectPostsForAllAccounts = <ThrowOnError extends boolean = false>(options?: Options<CollectPostsForAllAccountsData, ThrowOnError>): RequestResult<CollectPostsForAllAccountsResponses, unknown, ThrowOnError> => (options?.client ?? client).post<CollectPostsForAllAccountsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer/connected_accounts/collect_posts',
    ...options
});

/**
 * Ignore/un-ignore posts for a connected account
 */
export const ignorePosts = <ThrowOnError extends boolean = false>(options: Options<IgnorePostsData, ThrowOnError>): RequestResult<IgnorePostsResponses, unknown, ThrowOnError> => (options.client ?? client).post<IgnorePostsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer/connected_accounts/{account_id}/ignore_posts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Trigger video processing for one or more connected accounts
 */
export const processVideos = <ThrowOnError extends boolean = false>(options: Options<ProcessVideosData, ThrowOnError>): RequestResult<ProcessVideosResponses, ProcessVideosErrors, ThrowOnError> => (options.client ?? client).post<ProcessVideosResponses, ProcessVideosErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer/process_videos',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Trigger video processing for a connected account
 *
 * Deprecated: use POST /api/influencer/process_videos instead.
 *
 * @deprecated
 */
export const processSourceVideos = <ThrowOnError extends boolean = false>(options: Options<ProcessSourceVideosData, ThrowOnError>): RequestResult<ProcessSourceVideosResponses, unknown, ThrowOnError> => (options.client ?? client).post<ProcessSourceVideosResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer/connected_accounts/{account_id}/process_videos',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Trigger video processing for all active accounts of an influencer
 *
 * Deprecated: the studio no longer exposes a process-all control. Use auto-process or POST /api/influencer/process_videos.
 *
 * @deprecated
 */
export const processAccounts = <ThrowOnError extends boolean = false>(options?: Options<ProcessAccountsData, ThrowOnError>): RequestResult<ProcessAccountsResponses, unknown, ThrowOnError> => (options?.client ?? client).post<ProcessAccountsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer/connected_accounts/process_accounts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * List processing batches for the influencer's pool, newest first
 */
export const listProcessingBatches = <ThrowOnError extends boolean = false>(options?: Options<ListProcessingBatchesData, ThrowOnError>): RequestResult<ListProcessingBatchesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListProcessingBatchesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer/batches',
    ...options
});

/**
 * One processing batch with its per-video items
 */
export const getProcessingBatch = <ThrowOnError extends boolean = false>(options: Options<GetProcessingBatchData, ThrowOnError>): RequestResult<GetProcessingBatchResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetProcessingBatchResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer/batches/{batch_id}',
    ...options
});

/**
 * Ignore a batch's failed videos
 *
 * Marks the batch's failed posts as ignored so they drop out of post lists and failure counts. Optionally pass a subset of public post or video IDs; omit to ignore every failed post still in the batch.
 */
export const ignoreProcessingBatchFailed = <ThrowOnError extends boolean = false>(options: Options<IgnoreProcessingBatchFailedData, ThrowOnError>): RequestResult<IgnoreProcessingBatchFailedResponses, unknown, ThrowOnError> => (options.client ?? client).post<IgnoreProcessingBatchFailedResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer/batches/{batch_id}/ignore_failed',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get pending videos for a connected account
 */
export const getPendingVideos = <ThrowOnError extends boolean = false>(options: Options<GetPendingVideosData, ThrowOnError>): RequestResult<GetPendingVideosResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetPendingVideosResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer/connected_accounts/{account_id}/pending_videos',
    ...options
});

/**
 * Disconnect and permanently remove a connected account
 *
 * Soft-disconnects the account and immediately starts permanent removal.
 */
export const disconnectConnectedAccount = <ThrowOnError extends boolean = false>(options: Options<DisconnectConnectedAccountData, ThrowOnError>): RequestResult<DisconnectConnectedAccountResponses, DisconnectConnectedAccountErrors, ThrowOnError> => (options.client ?? client).delete<DisconnectConnectedAccountResponses, DisconnectConnectedAccountErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer/connected_accounts/{account_id}',
    ...options
});

/**
 * Get a connected account
 */
export const getConnectedAccount = <ThrowOnError extends boolean = false>(options: Options<GetConnectedAccountData, ThrowOnError>): RequestResult<GetConnectedAccountResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetConnectedAccountResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer/connected_accounts/{account_id}',
    ...options
});

/**
 * Trigger an immediate verification check
 *
 * Starts the verification workflow to check the account's bio for the verification code, or signals it to check immediately if already running.
 */
export const verifyConnectedAccountNow = <ThrowOnError extends boolean = false>(options: Options<VerifyConnectedAccountNowData, ThrowOnError>): RequestResult<VerifyConnectedAccountNowResponses, VerifyConnectedAccountNowErrors, ThrowOnError> => (options.client ?? client).post<VerifyConnectedAccountNowResponses, VerifyConnectedAccountNowErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer/connected_accounts/{account_id}/verify_now',
    ...options
});

/**
 * Admin: skip verification and accept the account
 *
 * Bypasses the bio-check verification and immediately marks the account as verified. Admin only.
 */
export const adminAcceptConnectedAccount = <ThrowOnError extends boolean = false>(options: Options<AdminAcceptConnectedAccountData, ThrowOnError>): RequestResult<AdminAcceptConnectedAccountResponses, AdminAcceptConnectedAccountErrors, ThrowOnError> => (options.client ?? client).post<AdminAcceptConnectedAccountResponses, AdminAcceptConnectedAccountErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer/connected_accounts/{account_id}/admin_accept',
    ...options
});

/**
 * Get all social accounts connected to the current user
 */
export const getConnectedAccounts = <ThrowOnError extends boolean = false>(options?: Options<GetConnectedAccountsData, ThrowOnError>): RequestResult<GetConnectedAccountsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetConnectedAccountsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer/connected_accounts',
    ...options
});

/**
 * Request connection of a social account
 *
 * Looks up the handle on the given platform and returns a verification code the influencer must post in their bio to prove ownership.
 */
export const connectSocialAccount = <ThrowOnError extends boolean = false>(options: Options<ConnectSocialAccountData, ThrowOnError>): RequestResult<ConnectSocialAccountResponses, ConnectSocialAccountErrors, ThrowOnError> => (options.client ?? client).post<ConnectSocialAccountResponses, ConnectSocialAccountErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer/connected_accounts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Trigger video processing for manually uploaded videos
 */
export const processDirectUploadVideos = <ThrowOnError extends boolean = false>(options: Options<ProcessDirectUploadVideosData, ThrowOnError>): RequestResult<ProcessDirectUploadVideosResponses, ProcessDirectUploadVideosErrors, ThrowOnError> => (options.client ?? client).post<ProcessDirectUploadVideosResponses, ProcessDirectUploadVideosErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer/videos/process',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete multiple influencer videos and their associated posts from the content library
 */
export const bulkDeleteInfluencerVideos = <ThrowOnError extends boolean = false>(options: Options<BulkDeleteInfluencerVideosData, ThrowOnError>): RequestResult<BulkDeleteInfluencerVideosResponses, BulkDeleteInfluencerVideosErrors, ThrowOnError> => (options.client ?? client).post<BulkDeleteInfluencerVideosResponses, BulkDeleteInfluencerVideosErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer/all_videos/bulk_delete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all posts for the current influencer
 */
export const getAllInfluencerPosts = <ThrowOnError extends boolean = false>(options?: Options<GetAllInfluencerPostsData, ThrowOnError>): RequestResult<GetAllInfluencerPostsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetAllInfluencerPostsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer/all_posts',
    ...options
});

/**
 * Get all posts for the current influencer grouped by upload date
 */
export const getAllInfluencerPostsByDate = <ThrowOnError extends boolean = false>(options?: Options<GetAllInfluencerPostsByDateData, ThrowOnError>): RequestResult<GetAllInfluencerPostsByDateResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetAllInfluencerPostsByDateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer/all_posts_by_date',
    ...options
});

/**
 * Promote selected discovered posts to pending for queue processing
 */
export const promoteDiscoveredPosts = <ThrowOnError extends boolean = false>(options: Options<PromoteDiscoveredPostsData, ThrowOnError>): RequestResult<PromoteDiscoveredPostsResponses, PromoteDiscoveredPostsErrors, ThrowOnError> => (options.client ?? client).post<PromoteDiscoveredPostsResponses, PromoteDiscoveredPostsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer/promote_discovered_posts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Search influencers by name (type-ahead)
 *
 * Fast prefix/substring search on influencer account_name and display_name. Prefix matches are ranked higher.
 */
export const searchInfluencers = <ThrowOnError extends boolean = false>(options?: Options<SearchInfluencersData, ThrowOnError>): RequestResult<SearchInfluencersResponses, SearchInfluencersErrors, ThrowOnError> => (options?.client ?? client).get<SearchInfluencersResponses, SearchInfluencersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencers/search',
    ...options
});

/**
 * Search social accounts linked to an influencer (type-ahead)
 *
 * Fast prefix/substring search on handle or platform for verified social accounts belonging to the given influencer. Prefix matches on handle are ranked higher.
 */
export const searchInfluencerSocialAccounts = <ThrowOnError extends boolean = false>(options: Options<SearchInfluencerSocialAccountsData, ThrowOnError>): RequestResult<SearchInfluencerSocialAccountsResponses, SearchInfluencerSocialAccountsErrors, ThrowOnError> => (options.client ?? client).get<SearchInfluencerSocialAccountsResponses, SearchInfluencerSocialAccountsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer/{influencer_id}/social_accounts/search',
    ...options
});

/**
 * Check whether the supplied handle is in a valid format and not already taken
 */
export const checkHandle = <ThrowOnError extends boolean = false>(options: Options<CheckHandleData, ThrowOnError>): RequestResult<CheckHandleResponses, CheckHandleErrors, ThrowOnError> => (options.client ?? client).get<CheckHandleResponses, CheckHandleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer/check_handle',
    ...options
});

/**
 * Get the influencer details associated with the current user
 */
export const getInfluencer = <ThrowOnError extends boolean = false>(options?: Options<GetInfluencerData, ThrowOnError>): RequestResult<GetInfluencerResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetInfluencerResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer',
    ...options
});

/**
 * Update the influencer details
 */
export const updateInfluencer = <ThrowOnError extends boolean = false>(options: Options<UpdateInfluencerData, ThrowOnError>): RequestResult<UpdateInfluencerResponses, unknown, ThrowOnError> => (options.client ?? client).patch<UpdateInfluencerResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Add an influencer account associated with the current user
 *
 * Deprecated: new users receive an influencer profile at registration. Set a public handle with PATCH /api/influencer or POST /api/influencer/complete_setup during referral onboarding.
 *
 * @deprecated
 */
export const addInfluencer = <ThrowOnError extends boolean = false>(options: Options<AddInfluencerData, ThrowOnError>): RequestResult<AddInfluencerResponses, unknown, ThrowOnError> => (options.client ?? client).post<AddInfluencerResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get the public profile of an influencer
 */
export const getInfluencerPublicProfile = <ThrowOnError extends boolean = false>(options: Options<GetInfluencerPublicProfileData, ThrowOnError>): RequestResult<GetInfluencerPublicProfileResponses, GetInfluencerPublicProfileErrors, ThrowOnError> => (options.client ?? client).get<GetInfluencerPublicProfileResponses, GetInfluencerPublicProfileErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencers/{influencer_id}',
    ...options
});

/**
 * List the influencers the current user subscribes to
 *
 * Subscribe is a rename of Follow — this lists the same user_influencer_follows relationship.
 */
export const getMySubscriptions = <ThrowOnError extends boolean = false>(options?: Options<GetMySubscriptionsData, ThrowOnError>): RequestResult<GetMySubscriptionsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetMySubscriptionsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/me/subscriptions',
    ...options
});

/**
 * Complete creator onboarding
 *
 * Finalises the referral-code onboarding flow: writes the influencer profile (display name, handle, bio, country), connects the invited social account in an unverified state (creating a pending verification with a bio code the creator completes later in Studio), and clears the onboarding flag. The social account to connect is taken from the invitation payload stored server-side, not the request body.
 */
export const completeCreatorSetup = <ThrowOnError extends boolean = false>(options: Options<CompleteCreatorSetupData, ThrowOnError>): RequestResult<CompleteCreatorSetupResponses, CompleteCreatorSetupErrors, ThrowOnError> => (options.client ?? client).post<CompleteCreatorSetupResponses, CompleteCreatorSetupErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer/complete_setup',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Connect a source for metadata discovery
 *
 * Starts verification like the standard connect flow, but on success runs metadata-only batch backfill instead of post collection with auto-processing.
 */
export const connectSocialAccountForDiscovery = <ThrowOnError extends boolean = false>(options: Options<ConnectSocialAccountForDiscoveryData, ThrowOnError>): RequestResult<ConnectSocialAccountForDiscoveryResponses, ConnectSocialAccountForDiscoveryErrors, ThrowOnError> => (options.client ?? client).post<ConnectSocialAccountForDiscoveryResponses, ConnectSocialAccountForDiscoveryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer/connected_accounts/discover',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get the pool associated with the current user's influencer account
 */
export const getInfluencerPool = <ThrowOnError extends boolean = false>(options?: Options<GetInfluencerPoolData, ThrowOnError>): RequestResult<GetInfluencerPoolResponses, GetInfluencerPoolErrors, ThrowOnError> => (options?.client ?? client).get<GetInfluencerPoolResponses, GetInfluencerPoolErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer/pool',
    ...options
});

/**
 * Broadcast connected account stats when they change (internal)
 */
export const postInternalConnectedAccountsStatsNotify = <ThrowOnError extends boolean = false>(options: Options<PostInternalConnectedAccountsStatsNotifyData, ThrowOnError>): RequestResult<PostInternalConnectedAccountsStatsNotifyResponses, PostInternalConnectedAccountsStatsNotifyErrors, ThrowOnError> => (options.client ?? client).post<PostInternalConnectedAccountsStatsNotifyResponses, PostInternalConnectedAccountsStatsNotifyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/internal/realtime/connected-accounts-stats',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Broadcast the step a Running question is on (internal)
 */
export const postInternalQuestionProgress = <ThrowOnError extends boolean = false>(options: Options<PostInternalQuestionProgressData, ThrowOnError>): RequestResult<PostInternalQuestionProgressResponses, PostInternalQuestionProgressErrors, ThrowOnError> => (options.client ?? client).post<PostInternalQuestionProgressResponses, PostInternalQuestionProgressErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/internal/realtime/question-progress',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Execute a job
 */
export const executeProjectJob = <ThrowOnError extends boolean = false>(options: Options<ExecuteProjectJobData, ThrowOnError>): RequestResult<ExecuteProjectJobResponses, unknown, ThrowOnError> => (options.client ?? client).patch<ExecuteProjectJobResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/projects/{project_id}/jobs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Display fields for account mentions, by public id
 *
 * Resolves the `social_account` and `influencer` mentions in a prompt to the handle, platform and profile picture a mention chip shows. A prompt carries a mention's identity only — it may have been stored days ago or pasted in from elsewhere — so display fields are read here instead of taken from it. Intentionally not scoped to the caller's pools or projects: a resolution discloses the handle and platform the mention already states plus a profile picture that is public on the platform. Ids that resolve to nothing are omitted from the results rather than erroring, so a caller can render the rest.
 */
export const resolveMentions = <ThrowOnError extends boolean = false>(options: Options<ResolveMentionsData, ThrowOnError>): RequestResult<ResolveMentionsResponses, ResolveMentionsErrors, ThrowOnError> => (options.client ?? client).get<ResolveMentionsResponses, ResolveMentionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/mentions/resolve',
    ...options
});

/**
 * Get the metering balance for the current user's account
 */
export const getMeteringBalance = <ThrowOnError extends boolean = false>(options?: Options<GetMeteringBalanceData, ThrowOnError>): RequestResult<GetMeteringBalanceResponses, GetMeteringBalanceErrors, ThrowOnError> => (options?.client ?? client).get<GetMeteringBalanceResponses, GetMeteringBalanceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/accounts/billing/balance',
    ...options
});

/**
 * Itemise the grants behind the current user's account balance
 */
export const getMeteringGrants = <ThrowOnError extends boolean = false>(options?: Options<GetMeteringGrantsData, ThrowOnError>): RequestResult<GetMeteringGrantsResponses, GetMeteringGrantsErrors, ThrowOnError> => (options?.client ?? client).get<GetMeteringGrantsResponses, GetMeteringGrantsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/accounts/billing/grants',
    ...options
});

/**
 * Get the config needed to connect to Knock's in-app feed
 */
export const getKnockFeedAuth = <ThrowOnError extends boolean = false>(options?: Options<GetKnockFeedAuthData, ThrowOnError>): RequestResult<GetKnockFeedAuthResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetKnockFeedAuthResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/accounts/knock-auth',
    ...options
});

/**
 * List notifications for the current user
 */
export const listNotifications = <ThrowOnError extends boolean = false>(options?: Options<ListNotificationsData, ThrowOnError>): RequestResult<ListNotificationsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListNotificationsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/notifications',
    ...options
});

/**
 * Create a new notification
 */
export const storeNotification = <ThrowOnError extends boolean = false>(options: Options<StoreNotificationData, ThrowOnError>): RequestResult<StoreNotificationResponses, StoreNotificationErrors, ThrowOnError> => (options.client ?? client).post<StoreNotificationResponses, StoreNotificationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/notifications',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List the available recurring billing plans
 *
 * Every plan on sale, AskGVT and Studio together. Each names its `product`; the free plan has none, since both share it.
 */
export const getBillingPlans = <ThrowOnError extends boolean = false>(options?: Options<GetBillingPlansData, ThrowOnError>): RequestResult<GetBillingPlansResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetBillingPlansResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/accounts/billing/plans',
    ...options
});

/**
 * List the available one-time packs, grouped by spendable unit
 */
export const getBillingTopups = <ThrowOnError extends boolean = false>(options?: Options<GetBillingTopupsData, ThrowOnError>): RequestResult<GetBillingTopupsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetBillingTopupsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/accounts/billing/topups',
    ...options
});

/**
 * Buy a top-up pack with a saved card
 */
export const purchaseTopup = <ThrowOnError extends boolean = false>(options: Options<PurchaseTopupData, ThrowOnError>): RequestResult<PurchaseTopupResponses, PurchaseTopupErrors, ThrowOnError> => (options.client ?? client).post<PurchaseTopupResponses, PurchaseTopupErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/accounts/billing/topups/{topup_id}/purchase',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Settle a top-up purchase after a 3-D Secure challenge
 */
export const confirmTopupPurchase = <ThrowOnError extends boolean = false>(options: Options<ConfirmTopupPurchaseData, ThrowOnError>): RequestResult<ConfirmTopupPurchaseResponses, ConfirmTopupPurchaseErrors, ThrowOnError> => (options.client ?? client).post<ConfirmTopupPurchaseResponses, ConfirmTopupPurchaseErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/accounts/billing/topups/purchase/confirm',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List every pool the current influencer directly curates
 *
 * Their private Studio pool and their AskPage pool - the pool selector for the per-pool account toggle UI. Consented public pools are excluded: the influencer only consents to those, they do not curate account/video membership within them.
 */
export const listMyPools = <ThrowOnError extends boolean = false>(options?: Options<ListMyPoolsData, ThrowOnError>): RequestResult<ListMyPoolsResponses, ListMyPoolsErrors, ThrowOnError> => (options?.client ?? client).get<ListMyPoolsResponses, ListMyPoolsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer/pools',
    ...options
});

/**
 * Enable or disable a connected account for a specific pool
 *
 * Disabling stops both visibility of the account's existing content in that pool and future ingestion of new posts from that account into that pool. For the AskPage pool, enabling copies the account's processed private-pool content; disabling removes that content from the AskPage. AskPage toggles are locked while membership_sync_status is copying or purging. Only affects the named pool - the same account can be enabled in one pool and disabled in another at the same time.
 */
export const setPoolAccountEnabled = <ThrowOnError extends boolean = false>(options: Options<SetPoolAccountEnabledData, ThrowOnError>): RequestResult<SetPoolAccountEnabledResponses, SetPoolAccountEnabledErrors, ThrowOnError> => (options.client ?? client).post<SetPoolAccountEnabledResponses, SetPoolAccountEnabledErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer/pool-accounts/{social_account_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List the influencer's verified accounts, plus their direct-upload account on an AskPage, with their enabled state for a given pool
 */
export const listPoolAccounts = <ThrowOnError extends boolean = false>(options: Options<ListPoolAccountsData, ThrowOnError>): RequestResult<ListPoolAccountsResponses, ListPoolAccountsErrors, ThrowOnError> => (options.client ?? client).get<ListPoolAccountsResponses, ListPoolAccountsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/influencer/pool-accounts',
    ...options
});

/**
 * List analysis categories
 */
export const listPoolAnalysisCategories = <ThrowOnError extends boolean = false>(options?: Options<ListPoolAnalysisCategoriesData, ThrowOnError>): RequestResult<ListPoolAnalysisCategoriesResponses, ListPoolAnalysisCategoriesErrors, ThrowOnError> => (options?.client ?? client).get<ListPoolAnalysisCategoriesResponses, ListPoolAnalysisCategoriesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/analysis_categories',
    ...options
});

/**
 * Create analysis category (admin only)
 */
export const createPoolAnalysisCategory = <ThrowOnError extends boolean = false>(options: Options<CreatePoolAnalysisCategoryData, ThrowOnError>): RequestResult<CreatePoolAnalysisCategoryResponses, CreatePoolAnalysisCategoryErrors, ThrowOnError> => (options.client ?? client).post<CreatePoolAnalysisCategoryResponses, CreatePoolAnalysisCategoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/analysis_categories',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete analysis category (admin only)
 */
export const deletePoolAnalysisCategory = <ThrowOnError extends boolean = false>(options: Options<DeletePoolAnalysisCategoryData, ThrowOnError>): RequestResult<DeletePoolAnalysisCategoryResponses, DeletePoolAnalysisCategoryErrors, ThrowOnError> => (options.client ?? client).delete<DeletePoolAnalysisCategoryResponses, DeletePoolAnalysisCategoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/analysis_categories/{analysis_category_id}',
    ...options
});

/**
 * Get analysis category details
 */
export const getPoolAnalysisCategory = <ThrowOnError extends boolean = false>(options: Options<GetPoolAnalysisCategoryData, ThrowOnError>): RequestResult<GetPoolAnalysisCategoryResponses, GetPoolAnalysisCategoryErrors, ThrowOnError> => (options.client ?? client).get<GetPoolAnalysisCategoryResponses, GetPoolAnalysisCategoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/analysis_categories/{analysis_category_id}',
    ...options
});

/**
 * Update analysis category (admin only)
 */
export const updatePoolAnalysisCategory = <ThrowOnError extends boolean = false>(options: Options<UpdatePoolAnalysisCategoryData, ThrowOnError>): RequestResult<UpdatePoolAnalysisCategoryResponses, UpdatePoolAnalysisCategoryErrors, ThrowOnError> => (options.client ?? client).patch<UpdatePoolAnalysisCategoryResponses, UpdatePoolAnalysisCategoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/analysis_categories/{analysis_category_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List the current influencer's public-pool consents
 *
 * Includes proposed, accepted, declined, and revoked consents across every pool the influencer has been proposed for.
 */
export const listPoolConsents = <ThrowOnError extends boolean = false>(options?: Options<ListPoolConsentsData, ThrowOnError>): RequestResult<ListPoolConsentsResponses, ListPoolConsentsErrors, ThrowOnError> => (options?.client ?? client).get<ListPoolConsentsResponses, ListPoolConsentsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/pool-consents',
    ...options
});

/**
 * Accept a pending pool consent proposal
 *
 * Starts the backfill workflow that replicates the influencer's content into the pool.
 */
export const acceptPoolConsent = <ThrowOnError extends boolean = false>(options: Options<AcceptPoolConsentData, ThrowOnError>): RequestResult<AcceptPoolConsentResponses, AcceptPoolConsentErrors, ThrowOnError> => (options.client ?? client).post<AcceptPoolConsentResponses, AcceptPoolConsentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/pool-consents/{consent}/accept',
    ...options
});

/**
 * Decline a pending pool consent proposal
 */
export const declinePoolConsent = <ThrowOnError extends boolean = false>(options: Options<DeclinePoolConsentData, ThrowOnError>): RequestResult<DeclinePoolConsentResponses, DeclinePoolConsentErrors, ThrowOnError> => (options.client ?? client).post<DeclinePoolConsentResponses, DeclinePoolConsentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/pool-consents/{consent}/decline',
    ...options
});

/**
 * Delete a pool
 */
export const deletePool = <ThrowOnError extends boolean = false>(options: Options<DeletePoolData, ThrowOnError>): RequestResult<DeletePoolResponses, DeletePoolErrors, ThrowOnError> => (options.client ?? client).delete<DeletePoolResponses, DeletePoolErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/projects/{project_id}/pools/{pool_id}',
    ...options
});

/**
 * Get pool details
 */
export const getPool = <ThrowOnError extends boolean = false>(options: Options<GetPoolData, ThrowOnError>): RequestResult<GetPoolResponses, GetPoolErrors, ThrowOnError> => (options.client ?? client).get<GetPoolResponses, GetPoolErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/projects/{project_id}/pools/{pool_id}',
    ...options
});

/**
 * Update a pool
 */
export const updatePool = <ThrowOnError extends boolean = false>(options: Options<UpdatePoolData, ThrowOnError>): RequestResult<UpdatePoolResponses, UpdatePoolErrors, ThrowOnError> => (options.client ?? client).patch<UpdatePoolResponses, UpdatePoolErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/projects/{project_id}/pools/{pool_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List or search pools
 */
export const listProjectPools = <ThrowOnError extends boolean = false>(options: Options<ListProjectPoolsData, ThrowOnError>): RequestResult<ListProjectPoolsResponses, ListProjectPoolsErrors, ThrowOnError> => (options.client ?? client).get<ListProjectPoolsResponses, ListProjectPoolsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/projects/{project_id}/pools',
    ...options
});

/**
 * Create a pool (no longer supported)
 *
 * Project pools no longer collect content, so none can be created. Supporting them again needs a collection path rebuilt first.
 */
export const createPool = <ThrowOnError extends boolean = false>(options: Options<CreatePoolData, ThrowOnError>): RequestResult<unknown, CreatePoolErrors, ThrowOnError> => (options.client ?? client).post<unknown, CreatePoolErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/projects/{project_id}/pools',
    ...options
});

/**
 * Delete a project
 */
export const deleteProject = <ThrowOnError extends boolean = false>(options: Options<DeleteProjectData, ThrowOnError>): RequestResult<DeleteProjectResponses, DeleteProjectErrors, ThrowOnError> => (options.client ?? client).delete<DeleteProjectResponses, DeleteProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/projects/{project_id}',
    ...options
});

/**
 * Get project details
 */
export const getProject = <ThrowOnError extends boolean = false>(options: Options<GetProjectData, ThrowOnError>): RequestResult<GetProjectResponses, GetProjectErrors, ThrowOnError> => (options.client ?? client).get<GetProjectResponses, GetProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/projects/{project_id}',
    ...options
});

/**
 * Change the visibility and/or name of a project
 */
export const updateProject = <ThrowOnError extends boolean = false>(options: Options<UpdateProjectData, ThrowOnError>): RequestResult<UpdateProjectResponses, UpdateProjectErrors, ThrowOnError> => (options.client ?? client).patch<UpdateProjectResponses, UpdateProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/projects/{project_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List or search projects
 */
export const listProjects = <ThrowOnError extends boolean = false>(options?: Options<ListProjectsData, ThrowOnError>): RequestResult<ListProjectsResponses, ListProjectsErrors, ThrowOnError> => (options?.client ?? client).get<ListProjectsResponses, ListProjectsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/projects',
    ...options
});

/**
 * Create a project
 */
export const createProject = <ThrowOnError extends boolean = false>(options: Options<CreateProjectData, ThrowOnError>): RequestResult<CreateProjectResponses, CreateProjectErrors, ThrowOnError> => (options.client ?? client).post<CreateProjectResponses, CreateProjectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/projects',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a public AskPage by influencer handle
 *
 * Unauthenticated. Returns the same creator chrome the AskPage injects into pageVars (identity, banner, bio, prices, social channels, boards, video count). 404 when the AskPage is unpublished or has no enabled social account.
 */
export const getPublicAskPageInfluencer = <ThrowOnError extends boolean = false>(options: Options<GetPublicAskPageInfluencerData, ThrowOnError>): RequestResult<GetPublicAskPageInfluencerResponses, GetPublicAskPageInfluencerErrors, ThrowOnError> => (options.client ?? client).get<GetPublicAskPageInfluencerResponses, GetPublicAskPageInfluencerErrors, ThrowOnError>({ url: '/api/influencers/by-handle/{handle}', ...options });

/**
 * Get a public board
 */
export const getPublicBoard = <ThrowOnError extends boolean = false>(options: Options<GetPublicBoardData, ThrowOnError>): RequestResult<GetPublicBoardResponses, GetPublicBoardErrors, ThrowOnError> => (options.client ?? client).get<GetPublicBoardResponses, GetPublicBoardErrors, ThrowOnError>({ url: '/api/public/boards/{board_id}', ...options });

/**
 * List clips on a public board
 */
export const listPublicBoardClips = <ThrowOnError extends boolean = false>(options: Options<ListPublicBoardClipsData, ThrowOnError>): RequestResult<ListPublicBoardClipsResponses, ListPublicBoardClipsErrors, ThrowOnError> => (options.client ?? client).get<ListPublicBoardClipsResponses, ListPublicBoardClipsErrors, ThrowOnError>({ url: '/api/public/boards/{board_id}/clips', ...options });

/**
 * List or search public pools (authenticated users)
 *
 * Returns published public pools (is_active=true, not soft-deleted) for any authenticated user, including the mobile app. Admin users may pass include_inactive=true to include unpublished or soft-deleted pools; the parameter is ignored for non-admin callers. Does not require admin privileges.
 */
export const listPublicPools = <ThrowOnError extends boolean = false>(options?: Options<ListPublicPoolsData, ThrowOnError>): RequestResult<ListPublicPoolsResponses, ListPublicPoolsErrors, ThrowOnError> => (options?.client ?? client).get<ListPublicPoolsResponses, ListPublicPoolsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/public-pools',
    ...options
});

/**
 * Create a new public pool (admin only)
 *
 * Creates a public pool and starts its collection workflow. Requires an authenticated admin user.
 */
export const createPublicPool = <ThrowOnError extends boolean = false>(options: Options<CreatePublicPoolData, ThrowOnError>): RequestResult<CreatePublicPoolResponses, CreatePublicPoolErrors, ThrowOnError> => (options.client ?? client).post<CreatePublicPoolResponses, CreatePublicPoolErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/public-pools',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a public pool (admin only)
 *
 * Permanently deletes a public pool. Requires an authenticated admin user.
 */
export const deletePublicPool = <ThrowOnError extends boolean = false>(options: Options<DeletePublicPoolData, ThrowOnError>): RequestResult<DeletePublicPoolResponses, DeletePublicPoolErrors, ThrowOnError> => (options.client ?? client).delete<DeletePublicPoolResponses, DeletePublicPoolErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/public-pools/{public_pool_id}',
    ...options
});

/**
 * Get public pool details (authenticated users)
 *
 * Returns a single published public pool for any authenticated user. Returns 404 for unpublished or soft-deleted pools unless the caller is an admin and passes include_inactive=true. Does not require admin privileges.
 */
export const getPublicPool = <ThrowOnError extends boolean = false>(options: Options<GetPublicPoolData, ThrowOnError>): RequestResult<GetPublicPoolResponses, GetPublicPoolErrors, ThrowOnError> => (options.client ?? client).get<GetPublicPoolResponses, GetPublicPoolErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/public-pools/{public_pool_id}',
    ...options
});

/**
 * Update a public pool (admin only)
 *
 * Updates public pool metadata and configuration. Requires an authenticated admin user.
 */
export const updatePublicPool = <ThrowOnError extends boolean = false>(options: Options<UpdatePublicPoolData, ThrowOnError>): RequestResult<UpdatePublicPoolResponses, UpdatePublicPoolErrors, ThrowOnError> => (options.client ?? client).patch<UpdatePublicPoolResponses, UpdatePublicPoolErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/public-pools/{pool_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get the default public pool (authenticated users)
 *
 * Returns the default published public pool (oldest scope=public pool that is active and not soft-deleted). Admin users may pass include_inactive=true; the parameter is ignored for non-admin callers. Does not require admin privileges.
 */
export const getDefaultPublicPool = <ThrowOnError extends boolean = false>(options?: Options<GetDefaultPublicPoolData, ThrowOnError>): RequestResult<GetDefaultPublicPoolResponses, GetDefaultPublicPoolErrors, ThrowOnError> => (options?.client ?? client).get<GetDefaultPublicPoolResponses, GetDefaultPublicPoolErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/public-pools/public',
    ...options
});

/**
 * List the efforts a question can be asked at
 */
export const listQuestionEfforts = <ThrowOnError extends boolean = false>(options?: Options<ListQuestionEffortsData, ThrowOnError>): RequestResult<ListQuestionEffortsResponses, ListQuestionEffortsErrors, ThrowOnError> => (options?.client ?? client).get<ListQuestionEffortsResponses, ListQuestionEffortsErrors, ThrowOnError>({ url: '/api/public/efforts', ...options });

/**
 * List questions
 */
export const listProjectQuestions = <ThrowOnError extends boolean = false>(options: Options<ListProjectQuestionsData, ThrowOnError>): RequestResult<ListProjectQuestionsResponses, ListProjectQuestionsErrors, ThrowOnError> => (options.client ?? client).get<ListProjectQuestionsResponses, ListProjectQuestionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/projects/{project_id}/questions',
    ...options
});

/**
 * List questions for the authenticated user
 *
 * Returns questions belonging to the authenticated user, not scoped to any project.
 */
export const listUserQuestions = <ThrowOnError extends boolean = false>(options?: Options<ListUserQuestionsData, ThrowOnError>): RequestResult<ListUserQuestionsResponses, ListUserQuestionsErrors, ThrowOnError> => (options?.client ?? client).get<ListUserQuestionsResponses, ListUserQuestionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/user/questions',
    ...options
});

/**
 * Get a question
 *
 * Get a question by its ID.
 */
export const getQuestion = <ThrowOnError extends boolean = false>(options: Options<GetQuestionData, ThrowOnError>): RequestResult<GetQuestionResponses, GetQuestionErrors, ThrowOnError> => (options.client ?? client).get<GetQuestionResponses, GetQuestionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/questions/{question_id}/info',
    ...options
});

/**
 * Delete a question
 *
 * Delete a question by its ID. This will also cascade delete related records in users_questions table.
 */
export const deleteQuestion = <ThrowOnError extends boolean = false>(options: Options<DeleteQuestionData, ThrowOnError>): RequestResult<DeleteQuestionResponses, DeleteQuestionErrors, ThrowOnError> => (options.client ?? client).delete<DeleteQuestionResponses, DeleteQuestionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/projects/{project_id}/questions/{question_id}',
    ...options
});

/**
 * Get a stored conversation
 *
 * This returns the stored conversation associated with a question.
 */
export const getProjectQuestion = <ThrowOnError extends boolean = false>(options: Options<GetProjectQuestionData, ThrowOnError>): RequestResult<GetProjectQuestionResponses, GetProjectQuestionErrors, ThrowOnError> => (options.client ?? client).get<GetProjectQuestionResponses, GetProjectQuestionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/projects/{project_id}/questions/{question_id}',
    ...options
});

/**
 * Continue the conversation by asking another question
 *
 * After a question in the conversation has been fully answered, this endpoint can be used to ask a follow-up question.
 */
export const askFollowUpQuestion = <ThrowOnError extends boolean = false>(options: Options<AskFollowUpQuestionData, ThrowOnError>): RequestResult<AskFollowUpQuestionResponses, AskFollowUpQuestionErrors, ThrowOnError> => (options.client ?? client).patch<AskFollowUpQuestionResponses, AskFollowUpQuestionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/projects/{project_id}/questions/{question_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a single interaction of a stored conversation
 *
 * Returns the events of one interaction in the question's conversation, in the same newline-delimited format as the full conversation endpoint.
 */
export const getQuestionInteraction = <ThrowOnError extends boolean = false>(options: Options<GetQuestionInteractionData, ThrowOnError>): RequestResult<GetQuestionInteractionResponses, GetQuestionInteractionErrors, ThrowOnError> => (options.client ?? client).get<GetQuestionInteractionResponses, GetQuestionInteractionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/questions/{question_id}/interactions/{interaction_id}',
    ...options
});

/**
 * Rate an interaction
 *
 * Submit a rating for one of the artifacts an interaction produced. Ratings are stored on the artifact, so the request names the artifact being rated; the question ID is resolved to a conversation ID internally.
 */
export const patchInteraction = <ThrowOnError extends boolean = false>(options: Options<PatchInteractionData, ThrowOnError>): RequestResult<PatchInteractionResponses, PatchInteractionErrors, ThrowOnError> => (options.client ?? client).patch<PatchInteractionResponses, PatchInteractionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/questions/{question_id}/interactions/{interaction_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a user question
 *
 * Delete a user question by its ID.
 */
export const deleteUserQuestion = <ThrowOnError extends boolean = false>(options: Options<DeleteUserQuestionData, ThrowOnError>): RequestResult<DeleteUserQuestionResponses, DeleteUserQuestionErrors, ThrowOnError> => (options.client ?? client).delete<DeleteUserQuestionResponses, DeleteUserQuestionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/user/questions/{question_id}',
    ...options
});

/**
 * Undelete a question
 *
 * Undelete a question by its ID.
 */
export const undeleteQuestion = <ThrowOnError extends boolean = false>(options: Options<UndeleteQuestionData, ThrowOnError>): RequestResult<UndeleteQuestionResponses, UndeleteQuestionErrors, ThrowOnError> => (options.client ?? client).post<UndeleteQuestionResponses, UndeleteQuestionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/projects/{project_id}/questions/{question_id}/undelete',
    ...options
});

/**
 * Undelete a user question
 *
 * Undelete a user question by its ID.
 */
export const undeleteUserQuestion = <ThrowOnError extends boolean = false>(options: Options<UndeleteUserQuestionData, ThrowOnError>): RequestResult<UndeleteUserQuestionResponses, UndeleteUserQuestionErrors, ThrowOnError> => (options.client ?? client).post<UndeleteUserQuestionResponses, UndeleteUserQuestionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/user/questions/{question_id}/undelete',
    ...options
});

/**
 * Get ratings for a question
 *
 * Get the ratings stored against a question's artifacts. Ratings live on artifacts, so the caller lists the artifacts it has rendered; unrated artifacts and any that belong to another conversation are omitted.
 */
export const getRatings = <ThrowOnError extends boolean = false>(options: Options<GetRatingsData, ThrowOnError>): RequestResult<GetRatingsResponses, GetRatingsErrors, ThrowOnError> => (options.client ?? client).get<GetRatingsResponses, GetRatingsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/questions/{question_id}/ratings',
    ...options
});

/**
 * Get chat usage and credit costs for a question
 *
 * Returns billed credit usage and processing time for a question conversation.
 */
export const getChatCosts = <ThrowOnError extends boolean = false>(options: Options<GetChatCostsData, ThrowOnError>): RequestResult<GetChatCostsResponses, GetChatCostsErrors, ThrowOnError> => (options.client ?? client).get<GetChatCostsResponses, GetChatCostsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/questions/{question_id}/chat-costs',
    ...options
});

/**
 * Answer a question the agent asked while answering
 *
 * Answers a `user_input_requested` event from the interaction's stream, such as whether the agent may switch to a higher effort. Being accepted only means the answer was recorded: the agent's decision arrives on the stream as `user_input_request_resolved`.
 */
export const respondToQuestionInputRequest = <ThrowOnError extends boolean = false>(options: Options<RespondToQuestionInputRequestData, ThrowOnError>): RequestResult<RespondToQuestionInputRequestResponses, RespondToQuestionInputRequestErrors, ThrowOnError> => (options.client ?? client).post<RespondToQuestionInputRequestResponses, RespondToQuestionInputRequestErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/questions/{question_id}/interactions/{interaction_id}/input-requests/{request_id}/response',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Initiate a chat by asking a question
 *
 * Creates a question in one of three scopes: public_pool, influencer_pool, or project. For influencer_pool the target pool is resolved server-side and cannot be supplied by the caller.
 */
export const createQuestion = <ThrowOnError extends boolean = false>(options: Options<CreateQuestionData, ThrowOnError>): RequestResult<CreateQuestionResponses, CreateQuestionErrors, ThrowOnError> => (options.client ?? client).post<CreateQuestionResponses, CreateQuestionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/questions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get the settings schema
 *
 * Retrieves the settings schema including root metadata and children. Omit `paths` for the complete tree. When `paths` is provided, `children` contains only the subtrees rooted at those paths (any depth).
 */
export const getSettingsSchema = <ThrowOnError extends boolean = false>(options?: Options<GetSettingsSchemaData, ThrowOnError>): RequestResult<GetSettingsSchemaResponses, GetSettingsSchemaErrors, ThrowOnError> => (options?.client ?? client).get<GetSettingsSchemaResponses, GetSettingsSchemaErrors, ThrowOnError>({
    querySerializer: { parameters: { paths: { array: { explode: false } } } },
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/settings/schema',
    ...options
});

/**
 * Get settings children for a specific prefix
 *
 * Retrieves group metadata and immediate children for a given settings path prefix
 */
export const getSettingsChildren = <ThrowOnError extends boolean = false>(options: Options<GetSettingsChildrenData, ThrowOnError>): RequestResult<GetSettingsChildrenResponses, GetSettingsChildrenErrors, ThrowOnError> => (options.client ?? client).get<GetSettingsChildrenResponses, GetSettingsChildrenErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/settings/children/{prefix}',
    ...options
});

/**
 * Get definition for a specific setting
 *
 * Retrieves the complete definition including type, constraints, defaults, and scopes for a specific setting
 */
export const getSettingDefinition = <ThrowOnError extends boolean = false>(options: Options<GetSettingDefinitionData, ThrowOnError>): RequestResult<GetSettingDefinitionResponses, GetSettingDefinitionErrors, ThrowOnError> => (options.client ?? client).get<GetSettingDefinitionResponses, GetSettingDefinitionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/settings/definition/{path}',
    ...options
});

/**
 * Get effective setting values
 *
 * Retrieves effective values for settings under a prefix, respecting scope precedence (user > pool > project > global)
 */
export const getSettingsValues = <ThrowOnError extends boolean = false>(options: Options<GetSettingsValuesData, ThrowOnError>): RequestResult<GetSettingsValuesResponses, GetSettingsValuesErrors, ThrowOnError> => (options.client ?? client).get<GetSettingsValuesResponses, GetSettingsValuesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/settings/values',
    ...options
});

/**
 * Update multiple setting values
 *
 * Sets or updates multiple setting values with validation. Each setting is validated and stored in the appropriate scope based on context.
 */
export const updateSettings = <ThrowOnError extends boolean = false>(options: Options<UpdateSettingsData, ThrowOnError>): RequestResult<UpdateSettingsResponses, UpdateSettingsErrors, ThrowOnError> => (options.client ?? client).put<UpdateSettingsResponses, UpdateSettingsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/settings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reset settings to their default values
 *
 * Resets specified settings to their schema defaults. For global scope, sets values to schema defaults. For other scopes (project/pool/user), deletes the scoped override to fall back to lower scope or global default.
 */
export const resetSettings = <ThrowOnError extends boolean = false>(options: Options<ResetSettingsData, ThrowOnError>): RequestResult<ResetSettingsResponses, ResetSettingsErrors, ThrowOnError> => (options.client ?? client).post<ResetSettingsResponses, ResetSettingsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/settings/reset',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List or search social channels
 */
export const listProjectSocialChannels = <ThrowOnError extends boolean = false>(options: Options<ListProjectSocialChannelsData, ThrowOnError>): RequestResult<ListProjectSocialChannelsResponses, ListProjectSocialChannelsErrors, ThrowOnError> => (options.client ?? client).get<ListProjectSocialChannelsResponses, ListProjectSocialChannelsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: 'api/projects/{project_id}/social_channels',
    ...options
});

/**
 * Look up social channel information from handles
 *
 * Takes a list of social channel handles and returns their profile information from the respective platforms.
 */
export const getSocialChannelsInfo = <ThrowOnError extends boolean = false>(options: Options<GetSocialChannelsInfoData, ThrowOnError>): RequestResult<GetSocialChannelsInfoResponses, GetSocialChannelsInfoErrors, ThrowOnError> => (options.client ?? client).post<GetSocialChannelsInfoResponses, GetSocialChannelsInfoErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/social_channels/get_info',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove social channels from a project pool
 */
export const deleteProjectSocialChannels = <ThrowOnError extends boolean = false>(options: Options<DeleteProjectSocialChannelsData, ThrowOnError>): RequestResult<DeleteProjectSocialChannelsResponses, DeleteProjectSocialChannelsErrors, ThrowOnError> => (options.client ?? client).delete<DeleteProjectSocialChannelsResponses, DeleteProjectSocialChannelsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/projects/{project_id}/social_channels',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Search social channels by handle (type-ahead)
 *
 * Fast prefix search for social channel handles. Returns up to 10 results ordered by relevance.
 */
export const searchSocialChannels = <ThrowOnError extends boolean = false>(options?: Options<SearchSocialChannelsData, ThrowOnError>): RequestResult<SearchSocialChannelsResponses, SearchSocialChannelsErrors, ThrowOnError> => (options?.client ?? client).get<SearchSocialChannelsResponses, SearchSocialChannelsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/social_channels/search',
    ...options
});

/**
 * List or search social posts
 */
export const listProjectSocialPosts = <ThrowOnError extends boolean = false>(options: Options<ListProjectSocialPostsData, ThrowOnError>): RequestResult<ListProjectSocialPostsResponses, ListProjectSocialPostsErrors, ThrowOnError> => (options.client ?? client).get<ListProjectSocialPostsResponses, ListProjectSocialPostsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: 'api/projects/{project_id}/social_posts',
    ...options
});

/**
 * List the current user's Studio playbook questions from the last 24 hours, with their status
 */
export const getRecentStudioPlaybookQuestions = <ThrowOnError extends boolean = false>(options?: Options<GetRecentStudioPlaybookQuestionsData, ThrowOnError>): RequestResult<GetRecentStudioPlaybookQuestionsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetRecentStudioPlaybookQuestionsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/studio/recent-playbook-questions',
    ...options
});

/**
 * List pre-built playbooks scoped to one library or draft video
 */
export const getStudioVideoSuggestedQuestions = <ThrowOnError extends boolean = false>(options: Options<GetStudioVideoSuggestedQuestionsData, ThrowOnError>): RequestResult<GetStudioVideoSuggestedQuestionsResponses, GetStudioVideoSuggestedQuestionsErrors, ThrowOnError> => (options.client ?? client).get<GetStudioVideoSuggestedQuestionsResponses, GetStudioVideoSuggestedQuestionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/studio/videos/{video_id}/suggested-questions',
    ...options
});

/**
 * Stop the subscription renewing at the end of the period
 *
 * Entitlement continues until the current period ends. The account keeps any top-up packs it has bought, which never expire.
 */
export const cancelSubscription = <ThrowOnError extends boolean = false>(options?: Options<CancelSubscriptionData, ThrowOnError>): RequestResult<CancelSubscriptionResponses, CancelSubscriptionErrors, ThrowOnError> => (options?.client ?? client).delete<CancelSubscriptionResponses, CancelSubscriptionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/accounts/billing/subscription',
    ...options
});

/**
 * The account's current subscription, or null on the free plan
 */
export const getSubscription = <ThrowOnError extends boolean = false>(options?: Options<GetSubscriptionData, ThrowOnError>): RequestResult<GetSubscriptionResponses, GetSubscriptionErrors, ThrowOnError> => (options?.client ?? client).get<GetSubscriptionResponses, GetSubscriptionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/accounts/billing/subscription',
    ...options
});

/**
 * Move the subscription to a different plan
 *
 * An upgrade takes effect immediately and invoices the prorated difference. A downgrade is scheduled for the end of the current period. Moving to the free plan cancels.
 */
export const changeSubscriptionPlan = <ThrowOnError extends boolean = false>(options: Options<ChangeSubscriptionPlanData, ThrowOnError>): RequestResult<ChangeSubscriptionPlanResponses, ChangeSubscriptionPlanErrors, ThrowOnError> => (options.client ?? client).patch<ChangeSubscriptionPlanResponses, ChangeSubscriptionPlanErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/accounts/billing/subscription',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Subscribe the account to a plan with a saved card
 */
export const subscribeToPlan = <ThrowOnError extends boolean = false>(options: Options<SubscribeToPlanData, ThrowOnError>): RequestResult<SubscribeToPlanResponses, SubscribeToPlanErrors, ThrowOnError> => (options.client ?? client).post<SubscribeToPlanResponses, SubscribeToPlanErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/accounts/billing/subscription',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * What a plan change would cost, before committing to it
 */
export const previewSubscriptionChange = <ThrowOnError extends boolean = false>(options: Options<PreviewSubscriptionChangeData, ThrowOnError>): RequestResult<PreviewSubscriptionChangeResponses, PreviewSubscriptionChangeErrors, ThrowOnError> => (options.client ?? client).post<PreviewSubscriptionChangeResponses, PreviewSubscriptionChangeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/accounts/billing/subscription/preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Undo a pending cancellation or a scheduled downgrade
 */
export const resumeSubscription = <ThrowOnError extends boolean = false>(options?: Options<ResumeSubscriptionData, ThrowOnError>): RequestResult<ResumeSubscriptionResponses, ResumeSubscriptionErrors, ThrowOnError> => (options?.client ?? client).post<ResumeSubscriptionResponses, ResumeSubscriptionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/accounts/billing/subscription/resume',
    ...options
});

/**
 * Settle a subscription payment after a 3-D Secure challenge
 */
export const confirmSubscription = <ThrowOnError extends boolean = false>(options: Options<ConfirmSubscriptionData, ThrowOnError>): RequestResult<ConfirmSubscriptionResponses, ConfirmSubscriptionErrors, ThrowOnError> => (options.client ?? client).post<ConfirmSubscriptionResponses, ConfirmSubscriptionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/accounts/billing/subscription/confirm',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Open a multipart upload session for a manually uploaded video.
 */
export const initUpload = <ThrowOnError extends boolean = false>(options?: Options<InitUploadData, ThrowOnError>): RequestResult<InitUploadResponses, InitUploadErrors, ThrowOnError> => (options?.client ?? client).post<InitUploadResponses, InitUploadErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/uploads/init',
    ...options
});

/**
 * Generate a presigned URL for one S3 multipart-upload REST operation.
 *
 * Backs @uppy/aws-s3's signRequest mode: the browser performs every S3 multipart operation itself (CreateMultipartUpload, UploadPart, CompleteMultipartUpload, AbortMultipartUpload, ListParts) against a URL presigned here. The request shape mirrors the plugin's PresignableRequest union exactly ({method, uploadId?, partNumber?}) so the frontend can forward signRequest's arguments unchanged. The real AWS UploadId is only ever visible to S3 and the browser; it is captured onto the session the first time a subsequent call reports one.
 */
export const signUploadRequest = <ThrowOnError extends boolean = false>(options?: Options<SignUploadRequestData, ThrowOnError>): RequestResult<SignUploadRequestResponses, SignUploadRequestErrors, ThrowOnError> => (options?.client ?? client).post<SignUploadRequestResponses, SignUploadRequestErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/uploads/sign',
    ...options
});

/**
 * Finalise an in-flight multipart upload for calendar processing.
 */
export const completeUpload = <ThrowOnError extends boolean = false>(options?: Options<CompleteUploadData, ThrowOnError>): RequestResult<CompleteUploadResponses, CompleteUploadErrors, ThrowOnError> => (options?.client ?? client).post<CompleteUploadResponses, CompleteUploadErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/uploads/complete',
    ...options
});

/**
 * Mark an in-flight multipart upload as failed after a browser-side transfer error.
 *
 * Called when Uppy reports a transfer error, the upload stalls, the user cancels, or the tab is closing mid-upload. Only pending/initiated sessions can fail this way; later statuses are left unchanged (idempotent replay returns the current row).
 */
export const failUpload = <ThrowOnError extends boolean = false>(options?: Options<FailUploadData, ThrowOnError>): RequestResult<FailUploadResponses, FailUploadErrors, ThrowOnError> => (options?.client ?? client).post<FailUploadResponses, FailUploadErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/uploads/fail',
    ...options
});

/**
 * Poll the status of a manual-upload session. Returns linked video info once transcoding completes.
 */
export const getUploadSession = <ThrowOnError extends boolean = false>(options?: Options<GetUploadSessionData, ThrowOnError>): RequestResult<GetUploadSessionResponses, GetUploadSessionErrors, ThrowOnError> => (options?.client ?? client).get<GetUploadSessionResponses, GetUploadSessionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/uploads/{public_id}',
    ...options
});

/**
 * Register a file uploaded to S3 by Uppy Companion for calendar processing.
 *
 * Called by the frontend after Companion finishes uploading a remote-source file (Google Drive, Dropbox, etc.) to the staging bucket. Creates an upload session and a calendar-discoverable direct-upload post. Processing starts immediately when the pool owner has auto-process on; otherwise it begins when the user selects the post in the calendar.
 */
export const registerCompanionUpload = <ThrowOnError extends boolean = false>(options?: Options<RegisterCompanionUploadData, ThrowOnError>): RequestResult<RegisterCompanionUploadResponses, RegisterCompanionUploadErrors, ThrowOnError> => (options?.client ?? client).post<RegisterCompanionUploadResponses, RegisterCompanionUploadErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/uploads/companion-register',
    ...options
});

/**
 * Get current user information
 */
export const getCurrentUser = <ThrowOnError extends boolean = false>(options?: Options<GetCurrentUserData, ThrowOnError>): RequestResult<GetCurrentUserResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetCurrentUserResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/user',
    ...options
});

/**
 * Patch the current user
 */
export const patchUser = <ThrowOnError extends boolean = false>(options: Options<PatchUserData, ThrowOnError>): RequestResult<PatchUserResponses, unknown, ThrowOnError> => (options.client ?? client).patch<PatchUserResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/user',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all accounts the current user belongs to
 */
export const listUserAccounts = <ThrowOnError extends boolean = false>(options?: Options<ListUserAccountsData, ThrowOnError>): RequestResult<ListUserAccountsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListUserAccountsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/user/accounts',
    ...options
});

/**
 * Switch the user's current account
 */
export const switchCurrentAccount = <ThrowOnError extends boolean = false>(options: Options<SwitchCurrentAccountData, ThrowOnError>): RequestResult<SwitchCurrentAccountResponses, SwitchCurrentAccountErrors, ThrowOnError> => (options.client ?? client).patch<SwitchCurrentAccountResponses, SwitchCurrentAccountErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/user/switch-account',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Request account deletion confirmation token
 */
export const requestUserDeletion = <ThrowOnError extends boolean = false>(options?: Options<RequestUserDeletionData, ThrowOnError>): RequestResult<RequestUserDeletionResponses, unknown, ThrowOnError> => (options?.client ?? client).post<RequestUserDeletionResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/user/deletion/request',
    ...options
});

/**
 * Confirm and delete current user account
 */
export const confirmUserDeletion = <ThrowOnError extends boolean = false>(options: Options<ConfirmUserDeletionData, ThrowOnError>): RequestResult<ConfirmUserDeletionResponses, ConfirmUserDeletionErrors, ThrowOnError> => (options.client ?? client).post<ConfirmUserDeletionResponses, ConfirmUserDeletionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/user/deletion/confirm',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List the discovery categories the current user follows
 */
export const listUserCategories = <ThrowOnError extends boolean = false>(options?: Options<ListUserCategoriesData, ThrowOnError>): RequestResult<ListUserCategoriesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListUserCategoriesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/user/categories',
    ...options
});

/**
 * Replace the discovery categories the current user follows
 */
export const replaceUserCategories = <ThrowOnError extends boolean = false>(options: Options<ReplaceUserCategoriesData, ThrowOnError>): RequestResult<ReplaceUserCategoriesResponses, ReplaceUserCategoriesErrors, ThrowOnError> => (options.client ?? client).put<ReplaceUserCategoriesResponses, ReplaceUserCategoriesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/user/categories',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Report a video for review
 *
 * Signed-in viewers only. Reports fold into the video's open moderation case; reporting again replaces the reporter's earlier reason.
 */
export const reportVideo = <ThrowOnError extends boolean = false>(options: Options<ReportVideoData, ThrowOnError>): RequestResult<ReportVideoResponses, ReportVideoErrors, ThrowOnError> => (options.client ?? client).post<ReportVideoResponses, ReportVideoErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/videos/{video_id}/reports',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Search videos by title/description (typeahead)
 */
export const searchVideos = <ThrowOnError extends boolean = false>(options?: Options<SearchVideosData, ThrowOnError>): RequestResult<SearchVideosResponses, SearchVideosErrors, ThrowOnError> => (options?.client ?? client).get<SearchVideosResponses, SearchVideosErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/videos/search',
    ...options
});

/**
 * List or search videos
 */
export const listProjectVideos = <ThrowOnError extends boolean = false>(options: Options<ListProjectVideosData, ThrowOnError>): RequestResult<ListProjectVideosResponses, ListProjectVideosErrors, ThrowOnError> => (options.client ?? client).get<ListProjectVideosResponses, ListProjectVideosErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/projects/{project_id}/videos',
    ...options
});

/**
 * Get video details
 *
 * Intentionally not scoped to a project or video owner. Any authenticated user may request details for any existing video by public id. Only checks that the video exists; returns time-limited presigned S3 URLs.
 */
export const getVideoById = <ThrowOnError extends boolean = false>(options: Options<GetVideoByIdData, ThrowOnError>): RequestResult<GetVideoByIdResponses, GetVideoByIdErrors, ThrowOnError> => (options.client ?? client).get<GetVideoByIdResponses, GetVideoByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/videos/{video_id}',
    ...options
});

/**
 * Evenly spaced preview frames for a time range with presigned URLs
 *
 * Intentionally not scoped to a project or video owner. Any authenticated user may request preview frames for any existing video by public id. Only checks that the video exists; returns time-limited presigned S3 URLs.
 */
export const getVideoSampledFrames = <ThrowOnError extends boolean = false>(options: Options<GetVideoSampledFramesData, ThrowOnError>): RequestResult<GetVideoSampledFramesResponses, GetVideoSampledFramesErrors, ThrowOnError> => (options.client ?? client).get<GetVideoSampledFramesResponses, GetVideoSampledFramesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/videos/{video_id}/sampled-frames',
    ...options
});

/**
 * Delete a video
 */
export const deleteVideo = <ThrowOnError extends boolean = false>(options: Options<DeleteVideoData, ThrowOnError>): RequestResult<DeleteVideoResponses, DeleteVideoErrors, ThrowOnError> => (options.client ?? client).delete<DeleteVideoResponses, DeleteVideoErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/projects/{project_id}/videos/{video_id}',
    ...options
});

/**
 * Get video details
 */
export const getVideo = <ThrowOnError extends boolean = false>(options: Options<GetVideoData, ThrowOnError>): RequestResult<GetVideoResponses, GetVideoErrors, ThrowOnError> => (options.client ?? client).get<GetVideoResponses, GetVideoErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/projects/{project_id}/videos/{video_id}',
    ...options
});

/**
 * Get video preview frames and segments
 *
 * Returns an ordered list of preview frames (GIFs/AVIFs) and segmentation images for a specific video to be used for seek-bar tooltips.
 */
export const getVideoPreviews = <ThrowOnError extends boolean = false>(options: Options<GetVideoPreviewsData, ThrowOnError>): RequestResult<GetVideoPreviewsResponses, GetVideoPreviewsErrors, ThrowOnError> => (options.client ?? client).get<GetVideoPreviewsResponses, GetVideoPreviewsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/projects/{project_id}/videos/{video_id}/previews',
    ...options
});

/**
 * List active workflows
 */
export const listProjectWorkflows = <ThrowOnError extends boolean = false>(options: Options<ListProjectWorkflowsData, ThrowOnError>): RequestResult<ListProjectWorkflowsResponses, ListProjectWorkflowsErrors, ThrowOnError> => (options.client ?? client).get<ListProjectWorkflowsResponses, ListProjectWorkflowsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/projects/{project_id}/workflows',
    ...options
});

/**
 * Get video completion progress for a workflow
 */
export const getVideoCompletionProgress = <ThrowOnError extends boolean = false>(options: Options<GetVideoCompletionProgressData, ThrowOnError>): RequestResult<GetVideoCompletionProgressResponses, GetVideoCompletionProgressErrors, ThrowOnError> => (options.client ?? client).get<GetVideoCompletionProgressResponses, GetVideoCompletionProgressErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/projects/{project_id}/workflows/{workflow_id}',
    ...options
});

/**
 * List agency–influencer relationships (As-Agency header)
 */
export const listAgencyHubInfluencers = <ThrowOnError extends boolean = false>(options: Options<ListAgencyHubInfluencersData, ThrowOnError>): RequestResult<ListAgencyHubInfluencersResponses, ListAgencyHubInfluencersErrors, ThrowOnError> => (options.client ?? client).get<ListAgencyHubInfluencersResponses, ListAgencyHubInfluencersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agency-hub/influencers',
    ...options
});

/**
 * Agency–influencer counts by status (As-Agency header)
 */
export const listAgencyHubInfluencerStats = <ThrowOnError extends boolean = false>(options: Options<ListAgencyHubInfluencerStatsData, ThrowOnError>): RequestResult<ListAgencyHubInfluencerStatsResponses, ListAgencyHubInfluencerStatsErrors, ThrowOnError> => (options.client ?? client).get<ListAgencyHubInfluencerStatsResponses, ListAgencyHubInfluencerStatsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agency-hub/influencers/stats',
    ...options
});

/**
 * Search influencers by handle (As-Agency header)
 */
export const searchAgencyHubInfluencers = <ThrowOnError extends boolean = false>(options: Options<SearchAgencyHubInfluencersData, ThrowOnError>): RequestResult<SearchAgencyHubInfluencersResponses, unknown, ThrowOnError> => (options.client ?? client).get<SearchAgencyHubInfluencersResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agency-hub/influencers/search',
    ...options
});

/**
 * Invite an influencer by email
 */
export const inviteAgencyHubInfluencerByEmail = <ThrowOnError extends boolean = false>(options: Options<InviteAgencyHubInfluencerByEmailData, ThrowOnError>): RequestResult<InviteAgencyHubInfluencerByEmailResponses, InviteAgencyHubInfluencerByEmailErrors, ThrowOnError> => (options.client ?? client).post<InviteAgencyHubInfluencerByEmailResponses, InviteAgencyHubInfluencerByEmailErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agency-hub/influencers/invite-email',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Invite an existing influencer by public ID
 */
export const inviteAgencyHubInfluencerByHandle = <ThrowOnError extends boolean = false>(options: Options<InviteAgencyHubInfluencerByHandleData, ThrowOnError>): RequestResult<InviteAgencyHubInfluencerByHandleResponses, InviteAgencyHubInfluencerByHandleErrors, ThrowOnError> => (options.client ?? client).post<InviteAgencyHubInfluencerByHandleResponses, InviteAgencyHubInfluencerByHandleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agency-hub/influencers/invite-handle',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get influencer profile and agency relationship
 */
export const getAgencyHubInfluencerDetail = <ThrowOnError extends boolean = false>(options: Options<GetAgencyHubInfluencerDetailData, ThrowOnError>): RequestResult<GetAgencyHubInfluencerDetailResponses, GetAgencyHubInfluencerDetailErrors, ThrowOnError> => (options.client ?? client).get<GetAgencyHubInfluencerDetailResponses, GetAgencyHubInfluencerDetailErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agency-hub/influencers/{influencer}',
    ...options
});

/**
 * Revoke a pending or accepted invite
 */
export const revokeAgencyHubInfluencerInvite = <ThrowOnError extends boolean = false>(options: Options<RevokeAgencyHubInfluencerInviteData, ThrowOnError>): RequestResult<RevokeAgencyHubInfluencerInviteResponses, RevokeAgencyHubInfluencerInviteErrors, ThrowOnError> => (options.client ?? client).delete<RevokeAgencyHubInfluencerInviteResponses, RevokeAgencyHubInfluencerInviteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agency-hub/influencers/{agencyInfluencer}',
    ...options
});

/**
 * Accept a pending agency invite on the influencer's behalf
 */
export const adminAcceptAgencyHubInfluencerInvite = <ThrowOnError extends boolean = false>(options: Options<AdminAcceptAgencyHubInfluencerInviteData, ThrowOnError>): RequestResult<AdminAcceptAgencyHubInfluencerInviteResponses, AdminAcceptAgencyHubInfluencerInviteErrors, ThrowOnError> => (options.client ?? client).post<AdminAcceptAgencyHubInfluencerInviteResponses, AdminAcceptAgencyHubInfluencerInviteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agency-hub/influencers/{agencyInfluencer}/admin_accept',
    ...options
});

/**
 * Send a reminder for a pending agency invite
 */
export const sendAgencyHubInfluencerInviteReminder = <ThrowOnError extends boolean = false>(options: Options<SendAgencyHubInfluencerInviteReminderData, ThrowOnError>): RequestResult<SendAgencyHubInfluencerInviteReminderResponses, SendAgencyHubInfluencerInviteReminderErrors, ThrowOnError> => (options.client ?? client).post<SendAgencyHubInfluencerInviteReminderResponses, SendAgencyHubInfluencerInviteReminderErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agency-hub/influencers/{agencyInfluencer}/send-reminder',
    ...options
});

/**
 * List groups for the agency (As-Agency header)
 */
export const listAgencyHubGroups = <ThrowOnError extends boolean = false>(options: Options<ListAgencyHubGroupsData, ThrowOnError>): RequestResult<ListAgencyHubGroupsResponses, ListAgencyHubGroupsErrors, ThrowOnError> => (options.client ?? client).get<ListAgencyHubGroupsResponses, ListAgencyHubGroupsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agency-hub/groups',
    ...options
});

/**
 * Create a group
 */
export const createAgencyHubGroup = <ThrowOnError extends boolean = false>(options: Options<CreateAgencyHubGroupData, ThrowOnError>): RequestResult<CreateAgencyHubGroupResponses, CreateAgencyHubGroupErrors, ThrowOnError> => (options.client ?? client).post<CreateAgencyHubGroupResponses, CreateAgencyHubGroupErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agency-hub/groups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List paginated influencers in a group
 */
export const listAgencyHubGroupInfluencers = <ThrowOnError extends boolean = false>(options: Options<ListAgencyHubGroupInfluencersData, ThrowOnError>): RequestResult<ListAgencyHubGroupInfluencersResponses, ListAgencyHubGroupInfluencersErrors, ThrowOnError> => (options.client ?? client).get<ListAgencyHubGroupInfluencersResponses, ListAgencyHubGroupInfluencersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agency-hub/groups/{group}/influencers',
    ...options
});

/**
 * Add an accepted influencer to a group
 */
export const addAgencyHubGroupInfluencer = <ThrowOnError extends boolean = false>(options: Options<AddAgencyHubGroupInfluencerData, ThrowOnError>): RequestResult<AddAgencyHubGroupInfluencerResponses, AddAgencyHubGroupInfluencerErrors, ThrowOnError> => (options.client ?? client).post<AddAgencyHubGroupInfluencerResponses, AddAgencyHubGroupInfluencerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agency-hub/groups/{group}/influencers',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a group
 */
export const deleteAgencyHubGroup = <ThrowOnError extends boolean = false>(options: Options<DeleteAgencyHubGroupData, ThrowOnError>): RequestResult<DeleteAgencyHubGroupResponses, DeleteAgencyHubGroupErrors, ThrowOnError> => (options.client ?? client).delete<DeleteAgencyHubGroupResponses, DeleteAgencyHubGroupErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agency-hub/groups/{group}',
    ...options
});

/**
 * Get a group with its influencers
 */
export const getAgencyHubGroup = <ThrowOnError extends boolean = false>(options: Options<GetAgencyHubGroupData, ThrowOnError>): RequestResult<GetAgencyHubGroupResponses, GetAgencyHubGroupErrors, ThrowOnError> => (options.client ?? client).get<GetAgencyHubGroupResponses, GetAgencyHubGroupErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agency-hub/groups/{group}',
    ...options
});

/**
 * Update a group
 */
export const updateAgencyHubGroup = <ThrowOnError extends boolean = false>(options: Options<UpdateAgencyHubGroupData, ThrowOnError>): RequestResult<UpdateAgencyHubGroupResponses, UpdateAgencyHubGroupErrors, ThrowOnError> => (options.client ?? client).patch<UpdateAgencyHubGroupResponses, UpdateAgencyHubGroupErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agency-hub/groups/{group}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Restore a soft-deleted group
 */
export const restoreAgencyHubGroup = <ThrowOnError extends boolean = false>(options: Options<RestoreAgencyHubGroupData, ThrowOnError>): RequestResult<RestoreAgencyHubGroupResponses, RestoreAgencyHubGroupErrors, ThrowOnError> => (options.client ?? client).post<RestoreAgencyHubGroupResponses, RestoreAgencyHubGroupErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agency-hub/groups/{group}/restore',
    ...options
});

/**
 * Remove an influencer from a group
 */
export const removeAgencyHubGroupInfluencer = <ThrowOnError extends boolean = false>(options: Options<RemoveAgencyHubGroupInfluencerData, ThrowOnError>): RequestResult<RemoveAgencyHubGroupInfluencerResponses, RemoveAgencyHubGroupInfluencerErrors, ThrowOnError> => (options.client ?? client).delete<RemoveAgencyHubGroupInfluencerResponses, RemoveAgencyHubGroupInfluencerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/agency-hub/groups/{group}/influencers/{influencer}',
    ...options
});

/**
 * List agencies the current influencer has joined
 */
export const listStudioAgencies = <ThrowOnError extends boolean = false>(options?: Options<ListStudioAgenciesData, ThrowOnError>): RequestResult<ListStudioAgenciesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListStudioAgenciesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/studio/agencies',
    ...options
});

/**
 * List pending agency invites for the current influencer
 */
export const listStudioAgencyInvites = <ThrowOnError extends boolean = false>(options?: Options<ListStudioAgencyInvitesData, ThrowOnError>): RequestResult<ListStudioAgencyInvitesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListStudioAgencyInvitesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/studio/agencies/invites',
    ...options
});

/**
 * Accept a pending agency invite
 */
export const acceptStudioAgencyInvite = <ThrowOnError extends boolean = false>(options: Options<AcceptStudioAgencyInviteData, ThrowOnError>): RequestResult<AcceptStudioAgencyInviteResponses, AcceptStudioAgencyInviteErrors, ThrowOnError> => (options.client ?? client).post<AcceptStudioAgencyInviteResponses, AcceptStudioAgencyInviteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/studio/agencies/invites/{agencyInfluencer}/accept',
    ...options
});

/**
 * Leave an agency (influencer revokes their own accepted membership)
 */
export const leaveStudioAgency = <ThrowOnError extends boolean = false>(options: Options<LeaveStudioAgencyData, ThrowOnError>): RequestResult<LeaveStudioAgencyResponses, LeaveStudioAgencyErrors, ThrowOnError> => (options.client ?? client).delete<LeaveStudioAgencyResponses, LeaveStudioAgencyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/studio/agencies/{agencyInfluencer}',
    ...options
});

/**
 * Decline a pending agency invite
 */
export const declineStudioAgencyInvite = <ThrowOnError extends boolean = false>(options: Options<DeclineStudioAgencyInviteData, ThrowOnError>): RequestResult<DeclineStudioAgencyInviteResponses, DeclineStudioAgencyInviteErrors, ThrowOnError> => (options.client ?? client).post<DeclineStudioAgencyInviteResponses, DeclineStudioAgencyInviteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/studio/agencies/invites/{agencyInfluencer}/decline',
    ...options
});

/**
 * Obtain a browser session
 *
 * Exchange a token returned by the OAuth callback for a browser session. The resulting session can then be used to display interactive web content within an app.
 */
export const getBrowserSession = <ThrowOnError extends boolean = false>(options: Options<GetBrowserSessionData, ThrowOnError>): RequestResult<unknown, GetBrowserSessionErrors, ThrowOnError> => (options.client ?? client).get<unknown, GetBrowserSessionErrors, ThrowOnError>({ url: '/api/mobile/auth/attach', ...options });

/**
 * Obtain an API token
 *
 * Exchange a code returned by the OAuth callback for an API token.
 */
export const getApiToken = <ThrowOnError extends boolean = false>(options: Options<GetApiTokenData, ThrowOnError>): RequestResult<GetApiTokenResponses, GetApiTokenErrors, ThrowOnError> => (options.client ?? client).post<GetApiTokenResponses, GetApiTokenErrors, ThrowOnError>({
    url: '/api/mobile/auth/exchange',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Whether the caller can ask another question
 *
 * Unauthenticated, or signed in with a bearer token. A signed-in caller always gets 204.
 */
export const checkPublicAskPageQuestion = <ThrowOnError extends boolean = false>(options: Options<CheckPublicAskPageQuestionData, ThrowOnError>): RequestResult<CheckPublicAskPageQuestionResponses, CheckPublicAskPageQuestionErrors, ThrowOnError> => (options.client ?? client).head<CheckPublicAskPageQuestionResponses, CheckPublicAskPageQuestionErrors, ThrowOnError>({ url: '/api/public/ask-page/{handle}/questions', ...options });

/**
 * Ask a question on an influencer's public AskPage
 *
 * Unauthenticated, or signed in with a bearer token. A guest has a global daily question allowance per visitor, across every creator; a signed-in caller spends their own credits instead. Pass thread_root_id to add a follow-up to a thread the caller asked, or to a private copy of a shared one. A paid AskPage additionally requires a valid entitlement or creator/team ownership.
 */
export const askPublicAskPageQuestion = <ThrowOnError extends boolean = false>(options: Options<AskPublicAskPageQuestionData, ThrowOnError>): RequestResult<AskPublicAskPageQuestionResponses, AskPublicAskPageQuestionErrors, ThrowOnError> => (options.client ?? client).post<AskPublicAskPageQuestionResponses, AskPublicAskPageQuestionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/public/ask-page/{handle}/questions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Stream a question's generated answer
 *
 * Server-sent, newline-delimited JSON events (the same protocol as GET /api/questions/{question_id}). Replays instantly for an already-finished answer; streams live for one still in progress.
 */
export const streamPublicAskPageQuestionAnswer = <ThrowOnError extends boolean = false>(options: Options<StreamPublicAskPageQuestionAnswerData, ThrowOnError, unknown>): Promise<ServerSentEventsResult<StreamPublicAskPageQuestionAnswerResponses>> => (options.client ?? client).sse.get<StreamPublicAskPageQuestionAnswerResponses, StreamPublicAskPageQuestionAnswerErrors, ThrowOnError>({ url: '/api/public/ask-page/{handle}/questions/{question_id}/stream', ...options });

/**
 * Search videos on a creator's public AskPage
 *
 * Unauthenticated. Scoped to the creator's AskPage pool for mention pickers on public pages.
 */
export const searchPublicAskPageVideos = <ThrowOnError extends boolean = false>(options: Options<SearchPublicAskPageVideosData, ThrowOnError>): RequestResult<SearchPublicAskPageVideosResponses, SearchPublicAskPageVideosErrors, ThrowOnError> => (options.client ?? client).get<SearchPublicAskPageVideosResponses, SearchPublicAskPageVideosErrors, ThrowOnError>({ url: '/api/public/ask-page/{handle}/videos/search', ...options });

/**
 * Continue the conversation by asking another question
 *
 * Project-scoped variant: PATCH /api/projects/{project_id}/questions/{question_id}. Same handler and response as this route.
 */
export const askFollowUpQuestionById = <ThrowOnError extends boolean = false>(options: Options<AskFollowUpQuestionByIdData, ThrowOnError>): RequestResult<AskFollowUpQuestionByIdResponses, AskFollowUpQuestionByIdErrors, ThrowOnError> => (options.client ?? client).patch<AskFollowUpQuestionByIdResponses, AskFollowUpQuestionByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/questions/{question_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
